var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 708,
    height: 752,
    viewBox: "0 0 708 752",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1579_43855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.323 357.969L257.281 367.886",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.461 350.477L267.419 360.835",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.6 343.203L277.778 353.562",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.958 335.709L288.135 346.288",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.536 327.996L298.935 338.795",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.336 320.283L309.735 331.303",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.356 312.348L320.754 323.588",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.595 304.412L332.214 315.873",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.056 296.26L343.675 307.941",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.737 288.104L355.355 299.784",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.638 279.729L367.477 291.85",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.759 271.135L379.599 283.477",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.322 262.539L392.161 275.101",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.105 253.723L404.944 266.505",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.108 244.688L418.167 257.691",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.552 235.652L431.611 248.876",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.217 226.395L445.276 239.838",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.322 216.92L459.381 230.805",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.647 207.221L473.927 221.326",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.634 197.303L488.914 211.849",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.841 187.383L504.341 202.149",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.489 177.027L519.989 192.234",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.577 166.67L536.077 182.097",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.886 155.869L552.827 171.958",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.636 145.068L569.578 161.377",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.607 134.051L586.989 150.801",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.797 122.809L604.62 139.999",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.429 111.57L622.472 128.981",
    stroke: "#1B171C",
    strokeWidth: 0.393842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.28 99.8887L640.764 117.741",
    stroke: "#1B171C",
    strokeWidth: 0.506242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.573 87.9863L659.497 106.279",
    stroke: "#1B171C",
    strokeWidth: 0.652583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.307 75.6465L678.452 94.6003",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.26 63.3066L697.846 82.7012",
    stroke: "#1B171C",
    strokeWidth: 1.13635,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.418 360.834L229.511 368.768",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.777 353.562L239.87 361.717",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.135 346.287L250.448 354.662",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.935 338.793L261.248 347.388",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.734 331.299L272.268 340.115",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.754 323.586L283.287 332.622",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.214 315.873L294.747 325.13",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.675 307.941L306.208 317.418",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.356 299.785L318.109 309.703",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.477 291.854L330.231 301.992",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.599 283.477L342.352 293.835",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.161 275.1L354.915 285.678",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.944 266.506L367.918 277.526",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.168 257.688L380.921 269.148",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.612 248.873L394.365 260.554",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.275 239.838L408.029 251.739",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.381 230.803L422.135 242.924",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.926 221.326L436.68 233.889",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.914 211.848L451.667 224.851",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.341 202.15L466.874 215.374",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.989 192.232L482.522 205.897",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.077 182.098L498.611 196.203",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.827 171.959L515.14 186.285",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.578 161.379L532.111 176.366",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.988 150.799L549.301 166.006",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.62 140L566.932 155.648",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.472 128.98L585.005 145.069",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.764 117.74L603.297 134.49",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.498 106.279L622.251 123.47",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.452 94.5977L641.426 112.449",
    stroke: "#1B171C",
    strokeWidth: 0.630103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.846 82.6973L660.82 100.99",
    stroke: "#1B171C",
    strokeWidth: 0.843664,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.682 70.5742L680.876 89.528",
    stroke: "#1B171C",
    strokeWidth: 1.11387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.957 58.2363L701.152 77.6309",
    stroke: "#1B171C",
    strokeWidth: 1.49625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.449 354.664L212.541 360.174",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.248 347.391L223.561 353.121",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.268 340.117L234.581 346.068",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.287 332.621L245.821 339.012",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.747 325.133L257.281 331.745",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.209 317.414L268.962 324.246",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.109 309.701L280.863 316.754",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.231 301.99L292.764 309.263",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.352 293.836L305.106 301.55",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.914 285.68L317.668 293.834",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.918 277.527L330.672 285.902",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.921 269.15L343.675 277.746",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.365 260.555L357.119 269.591",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.029 251.74L370.783 261.217",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.134 242.924L384.888 252.621",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.68 233.887L399.213 244.025",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.667 224.85L413.98 235.208",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.874 215.377L429.187 226.176",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.522 205.898L444.835 217.138",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.61 196.201L460.923 207.882",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.141 186.283L477.233 198.405",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.11 176.367L493.982 188.709",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.301 166.006L510.953 179.009",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.933 155.65L528.584 169.094",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.005 145.068L546.436 158.953",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.297 134.49L564.728 148.816",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.251 123.471L583.462 138.457",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.425 112.451L602.416 127.879",
    stroke: "#1B171C",
    strokeWidth: 0.461282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.82 100.99L622.031 117.079",
    stroke: "#1B171C",
    strokeWidth: 0.607403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.875 89.5312L641.866 106.061",
    stroke: "#1B171C",
    strokeWidth: 0.809944,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.152 77.6289L662.143 94.8195",
    stroke: "#1B171C",
    strokeWidth: 1.07992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.869 65.5078L682.859 83.58",
    stroke: "#1B171C",
    strokeWidth: 1.46253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.247 53.3848L704.017 71.8978",
    stroke: "#1B171C",
    strokeWidth: 1.99125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.561 353.119L188.298 355.543",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.581 346.068L199.538 348.713",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.82 339.016L210.777 341.881",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.281 331.744L222.238 335.05",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.961 324.248L233.919 327.995",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.862 316.756L246.04 320.723",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.764 309.262L258.162 313.449",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.106 301.551L270.504 306.179",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.669 293.836L283.067 298.685",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.671 285.9L295.849 290.969",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.674 277.744L309.073 283.254",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.119 269.59L322.517 275.54",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.783 261.217L335.961 267.388",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.888 252.621L350.066 259.453",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.214 244.025L364.392 251.078",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.98 235.211L379.158 242.704",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.188 226.172L394.365 234.106",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.835 217.137L409.793 225.512",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.923 207.883L425.661 216.699",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.233 198.404L441.97 207.661",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.983 188.707L458.5 198.404",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.953 179.01L475.469 189.148",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.584 169.092L492.88 179.891",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.436 158.953L510.512 170.193",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.729 148.814L528.584 160.495",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.462 138.457L547.097 150.579",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.416 127.879L566.051 140.662",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.03 117.078L585.445 130.302",
    stroke: "#1B171C",
    strokeWidth: 0.450042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.866 106.059L605.281 119.943",
    stroke: "#1B171C",
    strokeWidth: 0.596163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.142 94.8203L625.337 109.587",
    stroke: "#1B171C",
    strokeWidth: 0.798704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.859 83.5781L646.053 98.7852",
    stroke: "#1B171C",
    strokeWidth: 1.07992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.016 71.9004L666.99 87.9891",
    stroke: "#1B171C",
    strokeWidth: 1.47377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.836 59.998L688.59 76.7479",
    stroke: "#1B171C",
    strokeWidth: 2.01373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.298 355.544L157.443 354.883",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.538 348.713L168.683 348.492",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.778 341.879H180.143",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.238 335.049L191.604 335.269",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.919 327.996L203.505 328.657",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.04 320.723L215.406 321.825",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.162 313.449L227.748 314.772",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.504 306.174L240.09 307.937",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.066 298.682L252.652 300.665",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.85 290.969L265.656 293.393",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.073 283.256L278.659 286.121",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.517 275.543L292.103 278.628",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.961 267.385L305.767 270.911",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.066 259.453L319.652 263.2",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.391 251.076L334.197 255.484",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.158 242.705L348.744 247.554",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.365 234.109L363.95 239.399",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.792 225.514L379.378 231.023",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.66 216.697L395.026 222.648",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.969 207.658L411.335 214.27",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.499 198.404L427.864 205.677",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.469 189.148L444.614 196.862",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.881 179.891L461.806 188.045",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.512 170.193L479.437 179.009",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.584 160.496L497.288 169.753",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.098 150.582L515.802 160.5",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.052 140.662L534.535 151.021",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.445 130.303L553.709 141.543",
    stroke: "#1B171C",
    strokeWidth: 0.359901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.281 119.945L573.324 131.626",
    stroke: "#1B171C",
    strokeWidth: 0.472522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.336 109.586L593.38 121.928",
    stroke: "#1B171C",
    strokeWidth: 0.630103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.054 98.7871L613.877 111.79",
    stroke: "#1B171C",
    strokeWidth: 0.854904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.991 87.9863L634.814 101.651",
    stroke: "#1B171C",
    strokeWidth: 1.15883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.589 76.748L656.192 91.5144",
    stroke: "#1B171C",
    strokeWidth: 1.57493,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.628 65.5078L678.01 80.9353",
    stroke: "#1B171C",
    strokeWidth: 2.18255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.109 53.8262L700.491 70.3556",
    stroke: "#1B171C",
    strokeWidth: 3.02621,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.683 348.493L143.117 346.068",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.143 341.882L154.798 339.678",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.604 335.269L166.479 333.506",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.505 328.656L178.16 327.113",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.406 321.822L190.281 320.5",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.748 314.77L202.624 313.889",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.09 307.94L214.966 307.279",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.653 300.668L227.748 300.447",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.655 293.393L240.531 293.613",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.658 286.123L253.754 286.564",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.103 278.629L267.198 279.51",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.767 270.916L280.863 272.238",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.652 263.201L294.747 264.964",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.198 255.486L309.073 257.69",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.744 247.551L323.84 249.975",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.951 239.4L338.826 242.486",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.378 231.023L354.253 234.77",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.027 222.646L370.122 226.834",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.335 214.275L386.21 218.904",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.864 205.68L402.519 210.749",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.614 196.861L419.269 202.592",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.806 188.045L436.461 194.216",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.437 179.01L453.871 185.622",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.289 169.754L471.723 177.027",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.801 160.496L490.016 168.43",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.535 151.02L508.528 159.615",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.709 141.543L527.703 150.799",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.324 131.623L547.318 141.761",
    stroke: "#1B171C",
    strokeWidth: 0.405082,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.38 121.93L567.153 132.729",
    stroke: "#1B171C",
    strokeWidth: 0.539962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.876 111.789L587.649 123.47",
    stroke: "#1B171C",
    strokeWidth: 0.720023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.814 101.652L608.367 114.215",
    stroke: "#1B171C",
    strokeWidth: 0.978765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.192 91.5156L629.745 104.739",
    stroke: "#1B171C",
    strokeWidth: 1.33867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.01 80.9336L651.563 95.2591",
    stroke: "#1B171C",
    strokeWidth: 1.84513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.49 70.3574L673.823 85.5645",
    stroke: "#1B171C",
    strokeWidth: 2.55369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.191 59.3359L696.744 75.645",
    stroke: "#1B171C",
    strokeWidth: 3.58888,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.877 352.018L111.821 347.83",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.117 346.069L123.282 342.102",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.798 339.677L134.962 336.15",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.479 333.507L146.644 329.98",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.16 327.113L158.545 324.027",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.281 320.502L170.667 317.857",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.624 313.889L183.009 311.465",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.965 307.278L195.35 305.295",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.748 300.447L208.133 298.904",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.531 293.613L221.136 292.291",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.754 286.561L234.139 285.68",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.198 279.509L247.583 279.068",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.863 272.236H261.248",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.748 264.961L275.353 265.181",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.073 257.688L289.679 258.349",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.839 249.973L304.444 251.295",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.826 242.48L319.432 244.023",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.254 234.768L334.859 236.972",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.122 226.834L350.507 229.479",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.21 218.902L366.595 222.208",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.519 210.744L382.904 214.491",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.269 202.594L399.434 207.002",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.46 194.217L416.405 199.286",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.871 185.621L433.815 191.351",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.723 177.027L451.447 183.419",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.015 168.43L469.739 175.482",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.529 159.615L488.253 167.549",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.703 150.799L507.427 159.394",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.318 141.764L526.822 151.241",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.153 132.725L546.657 143.083",
    stroke: "#1B171C",
    strokeWidth: 0.495002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.65 123.471L567.153 134.711",
    stroke: "#1B171C",
    strokeWidth: 0.663823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.366 114.215L587.87 126.336",
    stroke: "#1B171C",
    strokeWidth: 0.888844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.745 104.74L609.248 117.964",
    stroke: "#1B171C",
    strokeWidth: 1.21503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.563 95.2598L631.067 109.585",
    stroke: "#1B171C",
    strokeWidth: 1.67631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.824 85.5625L653.548 100.99",
    stroke: "#1B171C",
    strokeWidth: 2.34013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.744 75.6465L676.248 92.3964",
    stroke: "#1B171C",
    strokeWidth: 3.27371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.106 65.7285L699.83 83.5803",
    stroke: "#1B171C",
    strokeWidth: 4.64632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.581 353.782L85.374 348.713",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.822 347.831L96.835 343.203",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.282 342.101L108.515 337.473",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.963 336.152L120.197 331.965",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.643 329.979L131.877 326.232",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.544 324.03L143.778 320.283",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.666 317.857L155.9 314.551",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.009 311.467L168.242 308.602",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.351 305.295L180.805 302.43",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.133 298.901L193.587 296.477",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.136 292.29L206.369 290.307",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.139 285.681L219.593 284.139",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 279.067L233.037 277.744",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.248 272.235L246.702 271.354",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.353 265.181L260.807 264.961",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.679 258.352L275.133 258.572",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.445 251.299L289.899 251.96",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.432 244.025L304.886 245.348",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.859 236.973L320.093 238.515",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.507 229.48L335.741 231.905",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.595 222.209L351.829 225.074",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.905 214.492L367.918 218.018",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.434 207L384.448 211.187",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.404 199.287L401.417 204.136",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.816 191.35L418.609 196.859",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.447 183.418L436.24 189.809",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.739 175.484L454.311 182.537",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.252 167.549L473.045 175.483",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.426 159.395L491.999 168.21",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.822 151.24L511.394 160.938",
    stroke: "#1B171C",
    strokeWidth: 0.359901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.657 143.086L531.229 153.885",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.153 134.711L551.725 146.612",
    stroke: "#1B171C",
    strokeWidth: 0.641343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.87 126.336L572.663 139.339",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.249 117.963L594.042 132.068",
    stroke: "#1B171C",
    strokeWidth: 1.18131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.067 109.586L615.86 124.793",
    stroke: "#1B171C",
    strokeWidth: 1.63135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.547 100.99L638.339 117.52",
    stroke: "#1B171C",
    strokeWidth: 2.27247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.247 92.3945L661.481 110.467",
    stroke: "#1B171C",
    strokeWidth: 3.18379,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.829 83.5781L685.063 103.193",
    stroke: "#1B171C",
    strokeWidth: 4.52268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.073 74.9844L709.527 96.1421",
    stroke: "#1B171C",
    strokeWidth: 6.47999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8944 359.512L51.6544 354.002",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1347 353.999L62.8947 348.93",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3741 348.712L74.3545 343.643",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8351 343.206L86.0359 338.357",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.515 337.474L97.4956 333.066",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.197 331.963L109.177 327.555",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.877 326.233L121.078 322.266",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.778 320.282L132.979 316.756",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9 314.552L145.321 311.025",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.242 308.599L157.664 305.514",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.804 302.43L170.225 299.785",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.587 296.479L182.788 294.055",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.37 290.31L195.791 288.326",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.593 284.136L209.015 282.373",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.038 277.745L222.459 276.643",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.701 271.353L236.123 270.691",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.808 264.965L250.229 264.744",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.133 258.57L264.554 258.791",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.899 251.959L279.099 252.62",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.886 245.35L294.087 246.672",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.093 238.516L309.293 240.499",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.741 231.906L324.942 234.331",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.829 225.07L340.809 228.156",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.918 218.02L356.898 221.987",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.447 211.189L373.207 215.597",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.418 204.133L390.178 209.422",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.608 196.861L407.148 203.032",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.239 189.811L424.779 196.863",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.312 182.535L442.852 190.469",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.045 175.484L461.364 184.3",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492 168.211L480.319 177.908",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.393 160.936L499.713 171.735",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.229 153.885L519.548 165.566",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.726 146.611L539.824 159.615",
    stroke: "#1B171C",
    strokeWidth: 0.652583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.663 139.342L560.762 153.667",
    stroke: "#1B171C",
    strokeWidth: 0.877604,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.041 132.066L582.36 147.714",
    stroke: "#1B171C",
    strokeWidth: 1.20379,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.859 124.791L604.399 141.761",
    stroke: "#1B171C",
    strokeWidth: 1.65383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.34 117.52L627.1 136.033",
    stroke: "#1B171C",
    strokeWidth: 2.29495,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.482 110.469L650.242 130.525",
    stroke: "#1B171C",
    strokeWidth: 3.21751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.063 103.193L674.264 125.012",
    stroke: "#1B171C",
    strokeWidth: 4.56764,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.527 96.1426L698.728 119.725",
    stroke: "#1B171C",
    strokeWidth: 6.54765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69426 374.06L-2.34186 367.889",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7142 369.21L8.89844 363.26",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9535 364.139L20.3582 358.629",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4143 359.071L31.819 353.781",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6546 353.999L43.0593 348.93",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8941 348.933L54.5191 344.084",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3551 343.644L66.2006 339.016",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0353 338.353L77.6603 333.945",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4963 333.064L89.3418 328.877",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.177 327.553L101.243 323.807",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.078 322.264L113.144 318.518",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.979 316.759L125.045 313.232",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.321 311.027L137.166 307.941",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.663 305.516L149.729 302.65",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.226 299.786L162.072 297.361",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.788 294.054L174.854 292.07",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.791 288.326L187.857 286.562",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.014 282.373L201.08 281.271",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.459 276.645L214.524 275.764",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.123 270.693L228.189 270.252",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.228 264.744L242.294 264.965",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.554 258.791L256.399 259.452",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.1 252.621L270.945 253.943",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.086 246.67L285.932 248.653",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.293 240.5L301.139 243.145",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.941 234.328L316.566 237.634",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.809 228.156L332.214 232.123",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.899 221.988L348.303 226.617",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.207 215.596L364.392 221.106",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.178 209.424L381.142 215.595",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.148 203.033L398.111 210.086",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.78 196.861L415.523 204.575",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.851 190.473L433.374 199.288",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.365 184.299L451.667 193.996",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.319 177.908L470.621 188.928",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.713 171.736L489.795 183.858",
    stroke: "#1B171C",
    strokeWidth: 0.382602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.548 165.566L509.63 178.79",
    stroke: "#1B171C",
    strokeWidth: 0.506242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.824 159.615L529.907 173.941",
    stroke: "#1B171C",
    strokeWidth: 0.675063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.762 153.666L551.065 169.314",
    stroke: "#1B171C",
    strokeWidth: 0.911324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.36 147.713L572.442 164.904",
    stroke: "#1B171C",
    strokeWidth: 1.23751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.399 141.764L594.702 160.497",
    stroke: "#1B171C",
    strokeWidth: 1.69879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.1 136.033L617.402 156.309",
    stroke: "#1B171C",
    strokeWidth: 2.35137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.241 130.523L640.764 152.563",
    stroke: "#1B171C",
    strokeWidth: 3.28496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.264 125.012L665.007 148.814",
    stroke: "#1B171C",
    strokeWidth: 4.64632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.728 119.725L689.912 145.29",
    stroke: "#1B171C",
    strokeWidth: 6.63757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89806 363.258L1.84546 357.527",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3589 358.629L13.3063 353.119",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8186 353.782L24.7661 348.492",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0591 348.934L36.2269 343.865",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5191 344.081L47.9073 339.232",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2004 339.015L59.3682 334.387",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6604 333.947L71.0486 329.539",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3419 328.877L82.7301 324.689",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.243 323.809L94.6311 319.842",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.144 318.518L106.532 314.992",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.045 313.228L118.433 309.922",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.167 307.939L130.775 305.074",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.729 302.649L143.117 300.004",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.071 297.36L155.679 295.156",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.854 292.069L168.463 290.086",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.857 286.563L181.245 285.24",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.08 281.272L194.469 280.17",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.525 275.763L207.913 275.322",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.189 270.252L221.578 270.472",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.294 264.961L235.462 265.402",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.399 259.453L249.567 260.775",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.945 253.943L264.113 255.927",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.932 248.654L278.88 251.079",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.139 243.145L293.866 246.23",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.566 237.635L309.073 241.602",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.214 232.125L324.721 236.753",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.303 226.617L340.59 232.127",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.392 221.104L356.457 227.275",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.141 215.596L372.987 222.648",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.112 210.086L389.737 218.02",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.522 204.578L406.927 213.394",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.374 199.287L424.558 208.984",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.668 193.996L442.852 204.795",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.621 188.926L461.364 200.827",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.796 183.861L480.539 196.864",
    stroke: "#1B171C",
    strokeWidth: 0.405082,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.631 178.789L500.154 193.115",
    stroke: "#1B171C",
    strokeWidth: 0.528722,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.906 173.939L520.429 189.587",
    stroke: "#1B171C",
    strokeWidth: 0.697543,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.064 169.312L541.367 186.283",
    stroke: "#1B171C",
    strokeWidth: 0.933804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.442 164.902L562.745 183.195",
    stroke: "#1B171C",
    strokeWidth: 1.25999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.702 160.496L585.005 180.331",
    stroke: "#1B171C",
    strokeWidth: 1.72127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.402 156.309L607.705 177.907",
    stroke: "#1B171C",
    strokeWidth: 2.37385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.765 152.562L631.288 175.704",
    stroke: "#1B171C",
    strokeWidth: 3.29642,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.008 148.814L655.531 173.719",
    stroke: "#1B171C",
    strokeWidth: 4.63508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.912 145.291L680.435 172.179",
    stroke: "#1B171C",
    strokeWidth: 6.59261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.257 142.203L706.221 171.075",
    stroke: "#1B171C",
    strokeWidth: 9.11258,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.84543 357.528L-4.76636 351.357",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3055 353.121L6.91406 347.17",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7663 348.494L18.3749 342.764",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2263 343.867L30.0552 338.357",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9077 339.235L41.7368 333.945",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3676 334.388L53.1965 329.539",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.049 329.536L64.8781 324.908",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7297 324.691L76.7791 320.283",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6305 319.842L88.4594 315.654",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.533 314.992L100.362 311.025",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.434 309.923L112.483 306.396",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 305.073L124.605 301.768",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.117 300.006L136.946 297.141",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68 295.156L149.509 292.512",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.462 290.087L162.291 288.104",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.245 285.24L175.074 283.477",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.469 280.17L188.298 279.068",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.913 275.321L201.522 274.66",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.577 270.472L214.966 270.252",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.462 265.406L228.85 266.067",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.567 260.775L242.955 261.877",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.113 255.928L257.281 257.691",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.879 251.076L271.827 253.721",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.866 246.229L286.593 249.534",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.073 241.602L301.8 245.569",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.721 236.752L317.007 241.601",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.589 232.125L332.655 237.635",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.458 227.275L348.303 233.667",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.987 222.646L364.392 229.699",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.737 218.02L380.921 225.954",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.928 213.393L397.892 222.429",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.559 208.984L415.303 218.902",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.852 204.795L433.155 215.594",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.364 200.83L451.447 212.511",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.539 196.861L470.18 209.865",
    stroke: "#1B171C",
    strokeWidth: 0.416322,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.153 193.115L489.574 207.22",
    stroke: "#1B171C",
    strokeWidth: 0.539962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.43 189.59L509.63 205.017",
    stroke: "#1B171C",
    strokeWidth: 0.708783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.367 186.283L530.347 203.033",
    stroke: "#1B171C",
    strokeWidth: 0.945044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.745 183.199L551.725 201.271",
    stroke: "#1B171C",
    strokeWidth: 1.25999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.005 180.33L573.544 199.945",
    stroke: "#1B171C",
    strokeWidth: 1.71003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.706 177.908L596.245 198.846",
    stroke: "#1B171C",
    strokeWidth: 2.32889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.287 175.705L619.827 198.406",
    stroke: "#1B171C",
    strokeWidth: 3.21751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.53 173.721L644.07 198.184",
    stroke: "#1B171C",
    strokeWidth: 4.4775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.435 172.178L668.975 198.625",
    stroke: "#1B171C",
    strokeWidth: 6.30015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.221 171.076L694.76 199.286",
    stroke: "#1B171C",
    strokeWidth: 8.93274,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91421 347.167L0.522827 339.895",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3754 342.76L12.2044 335.928",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0556 338.356L23.8846 331.965",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7362 333.946L35.5651 327.775",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1971 329.54L47.2466 323.369",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8776 324.91L58.9269 319.18",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7786 320.281L70.8279 314.771",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.46 315.655L82.5095 310.586",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.361 311.022L94.4104 306.174",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.483 306.396L106.532 301.768",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.604 301.768L118.654 297.58",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.946 297.139L130.775 293.393",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.509 292.513L143.338 289.207",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.291 288.105L155.9 285.24",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.075 283.475L168.683 281.051",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.298 279.066L181.686 277.303",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.521 274.66L194.689 273.338",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.965 270.251L208.133 269.59",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.85 266.066L221.797 265.846",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.955 261.877L235.682 262.318",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.281 257.688L249.567 258.789",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.826 253.723L263.892 255.486",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.593 249.537L278.659 252.182",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.8 245.566L293.425 248.872",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.007 241.602L308.412 245.789",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.655 237.635L323.619 242.483",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.303 233.666L339.046 239.176",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.392 229.701L354.915 236.313",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.921 225.955L371.003 233.228",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.891 222.428L387.533 230.362",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.303 218.902L404.504 227.938",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.154 215.596L421.914 225.513",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.447 212.51L439.766 223.529",
    stroke: "#1B171C",
    strokeWidth: 0.337421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.181 209.863L458.279 221.764",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.575 207.221L477.233 220.224",
    stroke: "#1B171C",
    strokeWidth: 0.551202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.631 205.016L496.848 219.121",
    stroke: "#1B171C",
    strokeWidth: 0.708783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.347 203.033L517.123 218.24",
    stroke: "#1B171C",
    strokeWidth: 0.933804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.725 201.27L538.061 218.019",
    stroke: "#1B171C",
    strokeWidth: 1.23751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.545 199.947L559.66 218.019",
    stroke: "#1B171C",
    strokeWidth: 1.64259,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.245 198.846L582.139 218.24",
    stroke: "#1B171C",
    strokeWidth: 2.21627,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.827 198.404L605.281 219.121",
    stroke: "#1B171C",
    strokeWidth: 3.02621,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.071 198.186L629.304 220.666",
    stroke: "#1B171C",
    strokeWidth: 4.15132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.974 198.623L653.988 222.425",
    stroke: "#1B171C",
    strokeWidth: 5.77143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.761 199.287L679.553 224.853",
    stroke: "#1B171C",
    strokeWidth: 8.07762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.428 200.607L706.001 227.716",
    stroke: "#1B171C",
    strokeWidth: 9.2814,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.523442 339.898L-5.42712 331.082",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2041 335.931L6.47388 327.336",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8845 331.961L18.1543 323.586",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5659 327.776L29.8357 319.621",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2465 323.368L41.5162 315.654",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9268 319.181L53.1965 311.688",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8286 314.769L64.8781 307.717",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.509 310.584L76.5584 303.752",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.41 306.176L88.4594 299.564",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.533 301.769L100.362 295.598",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.654 297.584L112.483 291.854",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.776 293.393L124.605 287.883",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.338 289.208L136.726 284.139",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9 285.242L149.288 280.613",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.683 281.049L161.851 277.082",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.686 277.306L174.633 273.779",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.689 273.338L187.636 270.473",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.134 269.592L200.64 267.168",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.798 265.845L213.864 264.082",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.682 262.319L227.527 261.217",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.567 258.792L241.192 258.352",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.893 255.486L255.297 255.707",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.659 252.18L269.623 253.061",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.425 248.873L283.948 250.636",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.412 245.789L298.715 247.993",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.619 242.48L313.481 245.566",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.046 239.176L328.688 243.143",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.915 236.314L343.896 240.943",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.003 233.227L359.542 238.736",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.533 230.361L375.632 236.753",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.503 227.938L392.161 234.99",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.915 225.514L408.911 233.448",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 223.527L426.322 232.343",
    stroke: "#1B171C",
    strokeWidth: 0.337421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.279 221.766L444.394 231.463",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.233 220.225L462.687 231.024",
    stroke: "#1B171C",
    strokeWidth: 0.539962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.847 219.121L481.861 230.802",
    stroke: "#1B171C",
    strokeWidth: 0.697543,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.124 218.24L501.476 231.243",
    stroke: "#1B171C",
    strokeWidth: 0.900084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.061 218.02L521.752 231.904",
    stroke: "#1B171C",
    strokeWidth: 1.18131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.66 218.02L542.91 233.006",
    stroke: "#1B171C",
    strokeWidth: 1.55245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.139 218.24L564.728 234.549",
    stroke: "#1B171C",
    strokeWidth: 2.06993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.281 219.121L587.209 236.753",
    stroke: "#1B171C",
    strokeWidth: 2.76747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.304 220.664L610.791 239.397",
    stroke: "#1B171C",
    strokeWidth: 3.74624,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.987 222.428L635.033 242.704",
    stroke: "#1B171C",
    strokeWidth: 5.11884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.553 224.85L659.938 246.228",
    stroke: "#1B171C",
    strokeWidth: 7.05389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706 227.717L685.945 250.638",
    stroke: "#1B171C",
    strokeWidth: 9.1463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.329 231.24L712.612 255.483",
    stroke: "#1B171C",
    strokeWidth: 9.45022,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47411 327.332L1.18469 316.312",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1545 323.587L12.8651 313.008",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8357 319.62L24.3259 309.262",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5161 315.654L36.0063 305.736",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1965 311.686L47.6867 302.209",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.878 307.719L59.3682 298.463",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5585 303.753L71.0486 294.717",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4603 299.564L82.7301 290.969",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.361 295.6L94.4104 287.225",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.482 291.848L106.311 283.693",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.604 287.884L118.433 280.17",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.726 284.138L130.334 276.865",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.288 280.611L142.677 273.779",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.851 277.083L155.019 270.691",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.634 273.781L167.361 267.83",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.636 270.471L180.143 264.961",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64 267.167L192.927 262.318",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.864 264.08L205.929 259.893",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.528 261.215L218.932 257.469",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.192 258.349L232.376 255.264",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.297 255.706L246.04 253.281",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.623 253.062L259.926 251.52",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.948 250.637L273.81 249.756",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.714 247.992L288.135 247.771",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.481 245.566L302.461 246.007",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.688 243.145L317.007 244.467",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.895 240.939L331.994 242.703",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.543 238.736L346.981 241.381",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.632 236.752L362.408 240.058",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.161 234.99L378.276 238.957",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.911 233.447L394.586 238.296",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.322 232.344L411.335 238.074",
    stroke: "#1B171C",
    strokeWidth: 0.337421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.394 231.463L428.526 238.075",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.687 231.023L446.378 238.296",
    stroke: "#1B171C",
    strokeWidth: 0.528722,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.861 230.803L464.67 239.178",
    stroke: "#1B171C",
    strokeWidth: 0.675063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.476 231.24L483.404 240.276",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.752 231.906L503.019 242.044",
    stroke: "#1B171C",
    strokeWidth: 1.11387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.91 233.008L523.295 244.248",
    stroke: "#1B171C",
    strokeWidth: 1.45129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.729 234.549L544.453 246.891",
    stroke: "#1B171C",
    strokeWidth: 1.90133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.209 236.752L566.272 249.976",
    stroke: "#1B171C",
    strokeWidth: 2.50873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.791 239.4L588.751 253.946",
    stroke: "#1B171C",
    strokeWidth: 3.34138,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.034 242.705L612.333 258.133",
    stroke: "#1B171C",
    strokeWidth: 4.4775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.938 246.229L636.577 262.978",
    stroke: "#1B171C",
    strokeWidth: 6.06389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.945 250.637L661.701 268.489",
    stroke: "#1B171C",
    strokeWidth: 8.28016,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.612 255.486L687.708 274.44",
    stroke: "#1B171C",
    strokeWidth: 9.2814,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18386 316.313L-3.00366 303.09",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8653 313.009L8.67786 299.785",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3251 309.262L20.1376 296.699",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0065 305.735L31.819 293.393",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6867 302.208L43.2789 290.086",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.368 298.464L54.7397 286.562",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0484 294.716L66.4201 283.035",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7297 290.969L77.881 279.729",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4099 287.221L89.5613 276.201",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.312 283.698L101.243 273.119",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.433 280.169L112.923 270.031",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.334 276.865L124.824 267.168",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.677 273.78L136.726 264.303",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.019 270.693L148.627 261.877",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.361 267.828L160.749 259.453",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.144 264.965L173.091 257.031",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.926 262.318L185.432 254.824",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 259.895L197.995 253.062",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.932 257.47L210.777 251.299",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.377 255.266L223.781 249.756",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.041 253.282L236.785 248.213",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.926 251.519L250.008 247.111",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.81 249.756L263.672 245.789",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.136 247.773L277.336 244.688",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.461 246.006L291.001 243.582",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.007 244.464L305.106 242.48",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.994 242.704L319.432 241.602",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.981 241.382L333.978 240.721",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.408 240.059H348.744",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.276 238.957L363.95 239.618",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.585 238.299L379.378 239.621",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.336 238.074L395.467 240.058",
    stroke: "#1B171C",
    strokeWidth: 0.337421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.526 238.074L411.776 240.719",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.378 238.299L428.747 241.825",
    stroke: "#1B171C",
    strokeWidth: 0.528722,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.671 239.176L446.157 243.363",
    stroke: "#1B171C",
    strokeWidth: 0.663823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.404 240.275L464.01 245.344",
    stroke: "#1B171C",
    strokeWidth: 0.832424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.019 242.043L482.743 247.773",
    stroke: "#1B171C",
    strokeWidth: 1.05744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.295 244.246L502.137 250.858",
    stroke: "#1B171C",
    strokeWidth: 1.36137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.453 246.893L522.193 254.606",
    stroke: "#1B171C",
    strokeWidth: 1.75499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.271 249.973L542.91 258.788",
    stroke: "#1B171C",
    strokeWidth: 2.28371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.751 253.943L564.508 263.641",
    stroke: "#1B171C",
    strokeWidth: 2.99249,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.334 258.133L586.989 268.932",
    stroke: "#1B171C",
    strokeWidth: 3.93754,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.577 262.979L610.35 274.88",
    stroke: "#1B171C",
    strokeWidth: 5.23124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.702 268.488L634.373 281.271",
    stroke: "#1B171C",
    strokeWidth: 7.00893,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.708 274.441L659.277 288.326",
    stroke: "#1B171C",
    strokeWidth: 9.11258,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.596 281.051L685.063 295.817",
    stroke: "#1B171C",
    strokeWidth: 9.38256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.366 288.326L711.731 303.974",
    stroke: "#1B171C",
    strokeWidth: 9.67502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67781 299.782L6.47388 284.795",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1376 296.7L17.9337 281.934",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8187 293.394L29.174 278.848",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2794 290.089L40.6348 275.764",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7401 286.561L51.875 272.676",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4204 283.034L63.3349 269.59",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.881 279.729L74.5751 266.285",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5621 276.204L86.0359 263.201",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.242 273.117L97.4956 260.334",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.924 270.029L108.957 257.688",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.824 267.168L120.416 255.047",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.726 264.302L131.877 252.842",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.627 261.877L143.558 250.637",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.749 259.454L155.239 248.654",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.091 257.028L167.14 246.67",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.433 254.824L179.041 245.127",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.995 253.059L191.163 243.582",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.778 251.298L203.505 242.262",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.781 249.754L215.847 241.379",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.784 248.214L228.409 240.5",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.008 247.111L241.192 239.838",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.672 245.792L253.975 239.4",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.336 244.687L266.978 238.736",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.001 243.584L280.422 238.074",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.106 242.483L293.645 237.635",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.432 241.602L307.31 237.414",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.977 240.719L321.194 236.973",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.743 240.058L335.299 236.973",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.951 239.617L349.845 236.973",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.378 239.618L364.392 237.414",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.467 240.062L379.599 238.299",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.776 240.721L395.247 239.619",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.747 241.82L411.115 241.379",
    stroke: "#1B171C",
    strokeWidth: 0.528722,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.158 243.363L427.645 243.584",
    stroke: "#1B171C",
    strokeWidth: 0.652583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.009 245.35L444.614 246.231",
    stroke: "#1B171C",
    strokeWidth: 0.821184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.742 247.771L462.246 249.755",
    stroke: "#1B171C",
    strokeWidth: 1.03496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.138 250.857L480.539 253.502",
    stroke: "#1B171C",
    strokeWidth: 1.30495,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.192 254.605L499.492 258.132",
    stroke: "#1B171C",
    strokeWidth: 1.66507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.91 258.791L519.108 263.199",
    stroke: "#1B171C",
    strokeWidth: 2.12635,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.508 263.641L539.604 268.93",
    stroke: "#1B171C",
    strokeWidth: 2.73375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.989 268.932L560.982 275.543",
    stroke: "#1B171C",
    strokeWidth: 3.5437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.35 274.881L583.022 282.374",
    stroke: "#1B171C",
    strokeWidth: 4.62384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.373 281.271L605.942 289.867",
    stroke: "#1B171C",
    strokeWidth: 6.07513,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.277 288.326L629.745 297.803",
    stroke: "#1B171C",
    strokeWidth: 8.0439,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.063 295.82L654.208 306.179",
    stroke: "#1B171C",
    strokeWidth: 9.2252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.731 303.973L679.553 315.213",
    stroke: "#1B171C",
    strokeWidth: 9.48394,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.5 313.008L706.001 324.909",
    stroke: "#1B171C",
    strokeWidth: 9.77641,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47388 284.798V268.709",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9345 281.933L17.7142 266.064",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1737 278.849L28.9533 263.422",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6342 275.762L39.973 260.555",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8745 272.674L51.2133 257.688",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3348 269.592L62.2328 254.605",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.575 266.286L73.473 251.74",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0355 263.199L84.4927 248.873",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4959 260.334L95.5123 246.229",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.957 257.691L106.753 243.807",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.417 255.046L117.772 241.602",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.878 252.843L129.012 239.619",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.558 250.636L140.252 237.854",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.239 248.654L151.492 236.092",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14 246.669L162.953 234.768",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.041 245.128L174.413 233.447",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.163 243.584L185.874 232.564",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.504 242.264L197.554 231.686",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.847 241.378L209.456 231.24",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.409 240.5L221.357 230.803",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.192 239.839L233.479 230.803",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.975 239.398L245.821 230.803",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.978 238.739L258.162 230.584",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.422 238.077L270.725 230.584",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.645 237.637L283.507 230.584",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.31 237.415L296.511 230.803",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.195 236.974L309.735 231.023",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.299 236.97L323.178 231.24",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.846 236.975L336.843 231.686",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.391 237.415L350.727 232.787",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.598 238.297L365.052 234.109",
    stroke: "#1B171C",
    strokeWidth: 0.359901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.246 239.616L379.599 235.869",
    stroke: "#1B171C",
    strokeWidth: 0.438802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.115 241.38L394.805 238.074",
    stroke: "#1B171C",
    strokeWidth: 0.539962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.644 243.586L410.233 240.721",
    stroke: "#1B171C",
    strokeWidth: 0.663823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.615 246.229L426.322 244.025",
    stroke: "#1B171C",
    strokeWidth: 0.832424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.246 249.756L442.852 248.213",
    stroke: "#1B171C",
    strokeWidth: 1.03496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.538 253.503L460.042 252.842",
    stroke: "#1B171C",
    strokeWidth: 1.28247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.492 258.133H477.673",
    stroke: "#1B171C",
    strokeWidth: 1.62011,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.107 263.201L496.186 264.303",
    stroke: "#1B171C",
    strokeWidth: 2.04745,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.604 268.932L515.581 270.915",
    stroke: "#1B171C",
    strokeWidth: 2.58763,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.982 275.543L535.637 278.408",
    stroke: "#1B171C",
    strokeWidth: 3.30744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.022 282.373L556.354 286.34",
    stroke: "#1B171C",
    strokeWidth: 4.24124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.942 289.867L578.173 294.936",
    stroke: "#1B171C",
    strokeWidth: 5.4675,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.745 297.801L600.432 303.751",
    stroke: "#1B171C",
    strokeWidth: 7.08761,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.209 306.174L623.794 313.226",
    stroke: "#1B171C",
    strokeWidth: 9.0901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.554 315.211L647.817 323.145",
    stroke: "#1B171C",
    strokeWidth: 9.3376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706 324.908L672.721 333.504",
    stroke: "#1B171C",
    strokeWidth: 9.59634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M733.329 335.27L698.507 344.746",
    stroke: "#1B171C",
    strokeWidth: 9.86633,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47388 268.71L8.67781 252.842",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7142 266.066L19.6977 250.197",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9533 263.419L30.4961 247.771",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.973 260.556L41.5157 244.908",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2133 257.689L52.3152 242.262",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2328 254.606L63.1143 239.619",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.473 251.739L74.1342 236.752",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4927 248.876L84.9335 234.109",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5123 246.232V231.906",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.752 243.806L106.311 229.701",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.772 241.602L117.11 227.717",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.013 239.619L127.911 225.955",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.252 237.856L138.71 224.412",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.492 236.093L149.509 223.311",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.952 234.771L160.308 222.209",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.413 233.444L171.107 221.543",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.873 232.568L182.126 220.887",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.554 231.684L193.367 220.664",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.456 231.241L204.607 220.441",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.357 230.802L215.847 220.664",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.478 230.801L227.527 221.104",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.82 230.799L238.988 221.543",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.162 230.581L250.889 221.766",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.724 230.584L262.79 222.209",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.507 230.581L275.133 222.867",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.511 230.804L287.475 223.311",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.735 231.021L299.817 223.969",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.178 231.243L312.599 224.631",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.842 231.685L325.602 225.514",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.727 232.788L338.826 226.617",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.053 234.107L352.27 228.377",
    stroke: "#1B171C",
    strokeWidth: 0.382602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.599 235.873L365.935 230.584",
    stroke: "#1B171C",
    strokeWidth: 0.472522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.806 238.077L380.26 233.008",
    stroke: "#1B171C",
    strokeWidth: 0.573683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.233 240.722L394.805 236.314",
    stroke: "#1B171C",
    strokeWidth: 0.697543,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.322 244.022L409.793 240.275",
    stroke: "#1B171C",
    strokeWidth: 0.854904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.852 248.214L425.22 244.908",
    stroke: "#1B171C",
    strokeWidth: 1.05744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.042 252.842L441.308 250.197",
    stroke: "#1B171C",
    strokeWidth: 1.31619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.673 258.13L458.058 256.367",
    stroke: "#1B171C",
    strokeWidth: 1.63135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.186 264.303L475.249 263.422",
    stroke: "#1B171C",
    strokeWidth: 2.03621,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.581 270.916L493.321 271.136",
    stroke: "#1B171C",
    strokeWidth: 2.54245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.637 278.408L512.275 279.51",
    stroke: "#1B171C",
    strokeWidth: 3.19503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.354 286.34L531.67 288.544",
    stroke: "#1B171C",
    strokeWidth: 4.02768,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.173 294.938L552.167 298.023",
    stroke: "#1B171C",
    strokeWidth: 5.1076,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.432 303.752L573.324 308.16",
    stroke: "#1B171C",
    strokeWidth: 6.50269,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.794 313.232L595.143 318.522",
    stroke: "#1B171C",
    strokeWidth: 8.32512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.817 323.146L617.843 329.317",
    stroke: "#1B171C",
    strokeWidth: 9.2252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.722 333.506L641.426 340.779",
    stroke: "#1B171C",
    strokeWidth: 9.45022,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.507 344.748L665.889 352.682",
    stroke: "#1B171C",
    strokeWidth: 9.69773,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.175 356.426L691.014 365.021",
    stroke: "#1B171C",
    strokeWidth: 9.95647,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.34186 255.045L1.62519 239.838",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67786 252.842L12.4245 237.635",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6975 250.196L23.0034 235.43",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4965 247.774L33.8024 233.008",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5162 244.907L44.3813 230.361",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3152 242.263L54.9599 227.938",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1143 239.619L65.5386 225.293",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1339 236.752L76.1174 222.867",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.934 234.106L86.6971 220.441",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5123 231.905L97.0551 218.24",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.311 229.702L107.413 216.479",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.11 227.718L117.772 214.715",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.911 225.955V213.393",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.709 224.413L138.268 212.291",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.509 223.307L148.627 211.406",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.307 222.205L158.985 210.744",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.107 221.547L169.344 210.527",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.126 220.886L179.922 210.527",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.367 220.665L190.502 210.527",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.607 220.444L201.08 210.967",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.847 220.665L211.879 211.629",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.528 221.107L222.679 212.291",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.988 221.547L233.919 213.393",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.889 221.765L244.938 214.051",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.791 222.207L256.399 214.934",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.132 222.867L268.079 216.035",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.475 223.311L279.761 216.92",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.817 223.97L291.662 217.799",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.599 224.632L303.784 218.682",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.603 225.514L316.126 220.004",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.826 226.616L328.468 221.326",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.27 228.38L341.25 223.311",
    stroke: "#1B171C",
    strokeWidth: 0.416322,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.934 230.583L354.474 225.514",
    stroke: "#1B171C",
    strokeWidth: 0.506242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.26 233.005L367.698 228.377",
    stroke: "#1B171C",
    strokeWidth: 0.618863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.806 236.314L381.362 231.906",
    stroke: "#1B171C",
    strokeWidth: 0.753744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.793 240.281L395.467 236.314",
    stroke: "#1B171C",
    strokeWidth: 0.911324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.22 244.907L410.013 241.602",
    stroke: "#1B171C",
    strokeWidth: 1.11387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.309 250.196L425 247.771",
    stroke: "#1B171C",
    strokeWidth: 1.37261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.059 256.367L440.648 254.824",
    stroke: "#1B171C",
    strokeWidth: 1.68755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.249 263.421L456.957 262.539",
    stroke: "#1B171C",
    strokeWidth: 2.08139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.322 271.135H473.707",
    stroke: "#1B171C",
    strokeWidth: 2.57617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.275 279.512L491.338 280.614",
    stroke: "#1B171C",
    strokeWidth: 3.19503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.67 288.545L509.63 290.749",
    stroke: "#1B171C",
    strokeWidth: 3.97126,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.167 298.023L528.805 301.329",
    stroke: "#1B171C",
    strokeWidth: 4.93878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.324 308.16L548.64 312.568",
    stroke: "#1B171C",
    strokeWidth: 6.17629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.143 318.518L569.357 324.027",
    stroke: "#1B171C",
    strokeWidth: 7.7402,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.843 329.318L590.955 335.93",
    stroke: "#1B171C",
    strokeWidth: 9.13506,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.425 340.779L613.215 348.273",
    stroke: "#1B171C",
    strokeWidth: 9.34884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.889 352.678L636.356 361.053",
    stroke: "#1B171C",
    strokeWidth: 9.57386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.014 365.02L660.159 374.056",
    stroke: "#1B171C",
    strokeWidth: 9.81013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.799 377.586L684.622 387.283",
    stroke: "#1B171C",
    strokeWidth: 10.0576,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.247 390.809L709.748 400.947",
    stroke: "#1B171C",
    strokeWidth: 10.3164,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.62482 239.838L6.03267 227.275",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4238 237.635L16.3909 225.293",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0034 235.432L26.9705 223.09",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8024 233.008L37.3287 220.887",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3807 230.36L47.6866 218.459",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9603 227.936L58.0458 216.035",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5388 225.292L68.4039 213.611",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1183 222.867L78.5426 211.406",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6967 220.445L88.6802 209.205",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0555 218.239L98.8187 207.439",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.413 216.479L108.736 205.68",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.772 214.712L118.654 204.354",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.911 213.39L128.572 203.252",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.268 212.291L138.489 202.594",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.627 211.407L148.186 202.15",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.985 210.746L158.104 202.15",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.344 210.525L168.021 202.15",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.923 210.528L177.939 202.594",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.502 210.525L188.077 203.252",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.081 210.965L197.995 204.133",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.88 211.628L208.354 205.236",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.679 212.289L218.712 206.559",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.919 213.393L229.291 207.883",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.939 214.054L239.87 209.205",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.399 214.935L250.669 210.527",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.08 216.035L261.688 212.068",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.761 216.919L272.929 213.393",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.662 217.798L284.389 214.492",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.784 218.682L296.07 215.816",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.125 220L307.75 217.355",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.468 221.327L319.652 218.902",
    stroke: "#1B171C",
    strokeWidth: 0.393842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.251 223.311L331.774 220.887",
    stroke: "#1B171C",
    strokeWidth: 0.461282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.474 225.514L344.336 223.311",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.698 228.378L356.898 226.395",
    stroke: "#1B171C",
    strokeWidth: 0.675063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.362 231.902L369.901 230.139",
    stroke: "#1B171C",
    strokeWidth: 0.821184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.467 236.313L383.125 234.99",
    stroke: "#1B171C",
    strokeWidth: 0.990005,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.013 241.602L396.79 240.721",
    stroke: "#1B171C",
    strokeWidth: 1.20379,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 247.771L410.895 247.551",
    stroke: "#1B171C",
    strokeWidth: 1.46253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.647 254.824L425.661 255.265",
    stroke: "#1B171C",
    strokeWidth: 1.78871,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.957 262.539L440.868 263.861",
    stroke: "#1B171C",
    strokeWidth: 2.18255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.706 271.135L456.736 273.339",
    stroke: "#1B171C",
    strokeWidth: 2.66631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.337 280.613L473.265 283.919",
    stroke: "#1B171C",
    strokeWidth: 3.25124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.631 290.75L490.457 294.937",
    stroke: "#1B171C",
    strokeWidth: 3.9825,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.804 301.328L508.528 306.838",
    stroke: "#1B171C",
    strokeWidth: 4.87134,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.64 312.566L527.262 318.958",
    stroke: "#1B171C",
    strokeWidth: 5.97375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.357 324.027L546.657 331.521",
    stroke: "#1B171C",
    strokeWidth: 7.34635,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.955 335.928L566.932 344.523",
    stroke: "#1B171C",
    strokeWidth: 9.06762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.215 348.271L588.09 357.748",
    stroke: "#1B171C",
    strokeWidth: 9.25892,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.356 361.055L610.13 371.413",
    stroke: "#1B171C",
    strokeWidth: 9.46146,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.158 374.059L632.83 385.299",
    stroke: "#1B171C",
    strokeWidth: 9.67502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.623 387.283L656.412 399.184",
    stroke: "#1B171C",
    strokeWidth: 9.88881,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.747 400.947L680.435 413.289",
    stroke: "#1B171C",
    strokeWidth: 10.1251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03259 227.276L9.33849 218.02",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3915 225.292L19.477 216.256",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.97 223.091L29.6148 214.275",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3289 220.886L39.7532 212.291",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6867 218.459L49.8906 210.305",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.0455 216.036L60.0291 208.322",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4045 213.611L69.9473 206.117",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5417 211.406L79.8641 204.133",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.68 209.203L89.782 202.371",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8184 207.442L99.4795 200.83",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.736 205.679L109.177 199.508",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.654 204.353V198.623",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.571 203.254L128.13 197.965",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.489 202.591L137.608 197.742",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.186 202.15L146.864 197.742",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.104 202.153L156.341 198.186",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.022 202.152L165.818 198.846",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.94 202.59L175.295 199.725",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.077 203.254L184.771 200.83",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.995 204.134L194.469 202.15",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.353 205.238L204.386 203.695",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.712 206.557L214.304 205.455",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.291 207.88L224.222 207.439",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.87 209.205H234.581",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.668 210.527L244.938 210.968",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.689 212.068L255.518 212.73",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.929 213.393L266.317 214.495",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.389 214.492L277.336 216.035",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.07 215.816L288.577 217.58",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.751 217.355L299.817 219.339",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.652 218.902L311.277 221.106",
    stroke: "#1B171C",
    strokeWidth: 0.438802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.774 220.887L322.958 223.091",
    stroke: "#1B171C",
    strokeWidth: 0.517482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.336 223.311L334.859 225.514",
    stroke: "#1B171C",
    strokeWidth: 0.618863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.899 226.395L346.981 228.598",
    stroke: "#1B171C",
    strokeWidth: 0.742503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.902 230.139L359.323 232.563",
    stroke: "#1B171C",
    strokeWidth: 0.900084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.125 234.99L372.105 237.855",
    stroke: "#1B171C",
    strokeWidth: 1.07992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.789 240.721L384.888 244.027",
    stroke: "#1B171C",
    strokeWidth: 1.30495,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.894 247.551L398.332 251.518",
    stroke: "#1B171C",
    strokeWidth: 1.57493,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.661 255.264L412.217 259.892",
    stroke: "#1B171C",
    strokeWidth: 1.90133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.869 263.859L426.543 269.149",
    stroke: "#1B171C",
    strokeWidth: 2.29495,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.736 273.338L441.529 279.729",
    stroke: "#1B171C",
    strokeWidth: 2.76747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.266 283.918L457.177 290.971",
    stroke: "#1B171C",
    strokeWidth: 3.33014,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.456 294.938L473.265 303.092",
    stroke: "#1B171C",
    strokeWidth: 4.01622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.529 306.838L490.457 316.094",
    stroke: "#1B171C",
    strokeWidth: 4.81514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.262 318.959L508.088 329.097",
    stroke: "#1B171C",
    strokeWidth: 5.79391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.657 331.521L526.822 342.761",
    stroke: "#1B171C",
    strokeWidth: 6.98645,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.933 344.523L546.216 356.645",
    stroke: "#1B171C",
    strokeWidth: 8.42628,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.091 357.752L566.272 370.755",
    stroke: "#1B171C",
    strokeWidth: 9.18002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.13 371.412L587.43 385.076",
    stroke: "#1B171C",
    strokeWidth: 9.34884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.83 385.297L609.248 399.402",
    stroke: "#1B171C",
    strokeWidth: 9.5289,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.413 399.182L631.508 413.728",
    stroke: "#1B171C",
    strokeWidth: 9.73145,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.436 413.291L654.65 428.278",
    stroke: "#1B171C",
    strokeWidth: 9.93399,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.01923 219.562L1.1847 212.51",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33862 218.018L11.1018 211.406",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4769 216.255L20.7992 209.863",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6152 214.273L30.7172 208.322",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7534 212.291L40.6349 206.781",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8906 210.305L50.3314 205.236",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0289 208.323V203.475",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9464 206.119L69.726 201.932",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8649 204.134L79.4241 200.607",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7823 202.373L88.9007 199.287",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4798 200.829L98.1575 198.404",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.177 199.508L107.413 197.965",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.654 198.624L116.45 197.742",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.131 197.963L125.486 197.742",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.608 197.742L134.522 198.183",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.864 197.742L143.558 198.844",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.341 198.186L152.594 199.949",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.818 198.846L161.63 201.49",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.295 199.725L170.667 203.031",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.771 200.83L179.922 204.577",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.469 202.15L189.179 206.779",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.386 203.695L198.656 208.764",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.304 205.455L208.133 211.185",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.222 207.439L218.051 213.61",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.581 209.205L227.969 215.817",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.939 210.967L238.107 218.019",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.517 212.73L248.244 220.003",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.317 214.492L258.823 222.206",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.336 216.035L269.402 223.969",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.576 217.58L280.422 225.735",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.816 219.342L291.441 227.496",
    stroke: "#1B171C",
    strokeWidth: 0.416322,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.277 221.104L302.682 229.258",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.958 223.09L313.922 231.465",
    stroke: "#1B171C",
    strokeWidth: 0.573683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.859 225.514L325.602 234.109",
    stroke: "#1B171C",
    strokeWidth: 0.686303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.981 228.6L337.284 236.975",
    stroke: "#1B171C",
    strokeWidth: 0.821184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.323 232.564L349.185 241.16",
    stroke: "#1B171C",
    strokeWidth: 0.990005,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.106 237.854L361.306 246.669",
    stroke: "#1B171C",
    strokeWidth: 1.18131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.889 244.025L373.649 253.502",
    stroke: "#1B171C",
    strokeWidth: 1.40633,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.332 251.52L386.431 261.437",
    stroke: "#1B171C",
    strokeWidth: 1.68755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.217 259.893L399.655 270.251",
    stroke: "#1B171C",
    strokeWidth: 2.01373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.543 269.15L413.319 280.39",
    stroke: "#1B171C",
    strokeWidth: 2.39633,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.53 279.729L427.424 291.63",
    stroke: "#1B171C",
    strokeWidth: 2.84637,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.177 290.969L442.41 303.752",
    stroke: "#1B171C",
    strokeWidth: 3.36386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.266 303.09L457.838 316.754",
    stroke: "#1B171C",
    strokeWidth: 3.97126,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.456 316.094L474.147 330.199",
    stroke: "#1B171C",
    strokeWidth: 4.68004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.088 329.096L491.118 344.303",
    stroke: "#1B171C",
    strokeWidth: 5.52393,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.821 342.764L508.969 358.632",
    stroke: "#1B171C",
    strokeWidth: 6.50269,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.216 356.648L527.482 373.178",
    stroke: "#1B171C",
    strokeWidth: 7.6613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.271 370.75L546.876 387.72",
    stroke: "#1B171C",
    strokeWidth: 9.04514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.429 385.078L567.153 402.489",
    stroke: "#1B171C",
    strokeWidth: 9.2252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.248 399.404L588.311 417.256",
    stroke: "#1B171C",
    strokeWidth: 9.38256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.508 413.729L609.909 431.58",
    stroke: "#1B171C",
    strokeWidth: 9.54014,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.649 428.273L632.39 446.125",
    stroke: "#1B171C",
    strokeWidth: 9.7202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18469 212.509V208.102",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1019 211.408L10.6611 207.221",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7988 209.864L20.1376 206.338",
    stroke: "#1B171C",
    strokeWidth: 0.0112511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7172 208.32L29.6152 205.455",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6345 206.778L39.0917 204.354",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3322 205.235L48.5691 203.252",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0289 203.473L57.825 202.371",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7266 201.933L67.082 201.492",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4233 200.607L76.3378 200.828",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9003 199.287L85.374 200.389",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1568 198.404L94.1897 200.388",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.413 197.965L103.006 200.61",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.449 197.742L111.821 201.268",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.485 197.742L120.416 202.37",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.522 198.186L129.012 203.695",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.558 198.846L137.608 205.457",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.594 199.947L146.203 207.661",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.63 201.492L154.798 210.087",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.666 203.033L163.614 212.51",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.923 204.578L172.429 215.157",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.179 206.781L181.466 218.021",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.656 208.76L190.502 220.881",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.133 211.189L199.978 223.972",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.051 213.611L209.456 226.835",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.969 215.816L219.153 229.701",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.107 218.02L229.071 232.345",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.245 220.004L239.209 234.77",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.823 222.209L249.567 237.196",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.403 223.969L259.926 239.176",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.422 225.732L270.725 241.16",
    stroke: "#1B171C",
    strokeWidth: 0.382602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.442 227.496L281.744 242.924",
    stroke: "#1B171C",
    strokeWidth: 0.450042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.682 229.26L292.764 244.908",
    stroke: "#1B171C",
    strokeWidth: 0.528722,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.922 231.463L304.004 246.89",
    stroke: "#1B171C",
    strokeWidth: 0.630103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.603 234.109L315.245 249.316",
    stroke: "#1B171C",
    strokeWidth: 0.742503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.283 236.973L326.704 252.18",
    stroke: "#1B171C",
    strokeWidth: 0.888844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.185 241.16L338.386 256.367",
    stroke: "#1B171C",
    strokeWidth: 1.05744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.306 246.67L350.066 262.097",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.648 253.504L362.188 269.372",
    stroke: "#1B171C",
    strokeWidth: 1.47377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.431 261.438L374.53 277.526",
    stroke: "#1B171C",
    strokeWidth: 1.74375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.654 270.252L387.312 287.002",
    stroke: "#1B171C",
    strokeWidth: 2.05869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.318 280.389L400.315 297.579",
    stroke: "#1B171C",
    strokeWidth: 2.41881,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.424 291.631L413.98 309.262",
    stroke: "#1B171C",
    strokeWidth: 2.82389,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.411 303.752L428.306 322.045",
    stroke: "#1B171C",
    strokeWidth: 3.28496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.838 316.756L443.292 335.489",
    stroke: "#1B171C",
    strokeWidth: 3.8139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.147 330.197L458.94 349.592",
    stroke: "#1B171C",
    strokeWidth: 4.39882,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.117 344.305L475.249 363.92",
    stroke: "#1B171C",
    strokeWidth: 5.07388,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.97 358.629L492.44 378.685",
    stroke: "#1B171C",
    strokeWidth: 5.83887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.482 373.178L510.512 393.454",
    stroke: "#1B171C",
    strokeWidth: 6.70501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.877 387.723L529.466 408.219",
    stroke: "#1B171C",
    strokeWidth: 7.72896,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.153 402.488L549.08 422.985",
    stroke: "#1B171C",
    strokeWidth: 8.91004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.311 417.254L569.578 437.53",
    stroke: "#1B171C",
    strokeWidth: 9.19148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.91 431.578L590.736 451.854",
    stroke: "#1B171C",
    strokeWidth: 9.32636,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.39 446.127L612.775 465.962",
    stroke: "#1B171C",
    strokeWidth: 9.4727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18429 208.101L-1.46045 206.338",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6613 207.219L7.57581 206.117",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1384 206.339L16.6121 205.898",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6147 205.455H25.868",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0917 204.354L34.9043 205.235",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5689 203.252L43.9407 205.015",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8257 202.371L52.9771 204.795",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0821 201.492L61.7927 204.578",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3387 200.83L70.6085 204.797",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3745 200.389L79.2036 205.237",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1898 200.389L87.578 206.339",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.006 200.607L95.9536 207.66",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.821 201.27L104.328 209.204",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.417 202.371L112.483 211.407",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.012 203.695L120.637 213.833",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.608 205.455L128.792 216.915",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.202 207.658L136.946 220.221",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.798 210.086L145.321 223.75",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.614 212.51L153.696 227.496",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.429 215.152L162.291 231.241",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.465 218.02L171.107 234.99",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.501 220.887L179.922 238.739",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.979 223.969L189.179 242.702",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.456 226.834L198.436 246.449",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.153 229.701L208.133 249.977",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.07 232.344L217.83 253.061",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.209 234.768L227.969 256.146",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.567 237.193L238.107 258.792",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.926 239.176L248.686 261.215",
    stroke: "#1B171C",
    strokeWidth: 0.359901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.724 241.16L259.484 263.199",
    stroke: "#1B171C",
    strokeWidth: 0.416322,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.744 242.924L270.283 265.183",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.764 244.908L281.303 266.947",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.004 246.893L292.323 268.932",
    stroke: "#1B171C",
    strokeWidth: 0.663823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.244 249.316L303.784 270.915",
    stroke: "#1B171C",
    strokeWidth: 0.776224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.705 252.18L315.024 273.558",
    stroke: "#1B171C",
    strokeWidth: 0.922564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.385 256.367L326.704 277.745",
    stroke: "#1B171C",
    strokeWidth: 1.09116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.066 262.1L338.165 283.478",
    stroke: "#1B171C",
    strokeWidth: 1.27123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.188 269.371L350.066 290.749",
    stroke: "#1B171C",
    strokeWidth: 1.49625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.53 277.527L361.967 299.346",
    stroke: "#1B171C",
    strokeWidth: 1.74375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.313 287.002L374.309 308.821",
    stroke: "#1B171C",
    strokeWidth: 2.03621,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.315 297.58L387.092 319.84",
    stroke: "#1B171C",
    strokeWidth: 2.35137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.98 309.262L400.536 331.742",
    stroke: "#1B171C",
    strokeWidth: 2.70003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.306 322.047L414.421 344.747",
    stroke: "#1B171C",
    strokeWidth: 3.08263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.292 335.488L428.966 358.409",
    stroke: "#1B171C",
    strokeWidth: 3.49874,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.941 349.594L444.174 372.735",
    stroke: "#1B171C",
    strokeWidth: 3.96002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.249 363.918L460.042 387.059",
    stroke: "#1B171C",
    strokeWidth: 4.45502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.44 378.686L476.792 401.827",
    stroke: "#1B171C",
    strokeWidth: 5.00622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.512 393.451L494.423 416.372",
    stroke: "#1B171C",
    strokeWidth: 5.61385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.466 408.217L512.936 430.917",
    stroke: "#1B171C",
    strokeWidth: 6.30015,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.081 422.988L532.331 445.248",
    stroke: "#1B171C",
    strokeWidth: 7.08761,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.577 437.531L552.386 459.35",
    stroke: "#1B171C",
    strokeWidth: 7.99894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.736 451.857L573.104 472.795",
    stroke: "#1B171C",
    strokeWidth: 9.07886,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.774 465.961L594.702 486.237",
    stroke: "#1B171C",
    strokeWidth: 9.19148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5758 206.117L2.06598 207.44",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6118 205.898L10.6611 207.882",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8682 205.455L19.4769 208.32",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9042 205.236L28.072 208.763",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9401 205.016L36.6671 209.423",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9771 204.795L45.2633 210.084",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7923 204.578L53.6378 210.97",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6076 204.795L62.0122 212.068",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2033 205.236L70.1672 213.611",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5786 206.338L78.3221 215.815",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9528 207.658L86.2554 218.017",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.328 209.205L94.1897 220.886",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.482 211.406L101.904 224.189",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.637 213.83L109.838 227.935",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.792 216.92L117.552 232.127",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.946 220.225L125.486 236.534",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.321 223.748L133.42 241.379",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.696 227.496L141.574 246.229",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.292 231.24L149.95 251.076",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.107 234.99L158.545 255.928",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.923 238.736L167.14 260.776",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.179 242.705L176.176 265.626",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.436 246.451L185.432 270.033",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.133 249.973L194.91 274.436",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.831 253.062L204.828 278.187",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.969 256.148L214.745 281.714",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.106 258.791L225.103 285.018",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.686 261.217L235.682 287.664",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.484 263.201L246.261 289.869",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.284 265.184L257.281 291.851",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.303 266.945L268.3 293.613",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.323 268.932L279.54 295.158",
    stroke: "#1B171C",
    strokeWidth: 0.663823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.784 270.916L290.781 297.143",
    stroke: "#1B171C",
    strokeWidth: 0.776224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.023 273.557L302.24 299.343",
    stroke: "#1B171C",
    strokeWidth: 0.911324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.704 277.744L313.701 303.089",
    stroke: "#1B171C",
    strokeWidth: 1.06868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.165 283.477L325.162 309.042",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.066 290.75L336.843 316.316",
    stroke: "#1B171C",
    strokeWidth: 1.45129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.967 299.346L348.744 324.691",
    stroke: "#1B171C",
    strokeWidth: 1.67631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.309 308.818L361.086 334.164",
    stroke: "#1B171C",
    strokeWidth: 1.92381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.093 319.842L373.649 344.967",
    stroke: "#1B171C",
    strokeWidth: 2.18255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.536 331.744L386.651 356.869",
    stroke: "#1B171C",
    strokeWidth: 2.47501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.421 344.748L400.096 369.873",
    stroke: "#1B171C",
    strokeWidth: 2.77871,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.967 358.41L414.421 383.315",
    stroke: "#1B171C",
    strokeWidth: 3.09387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.174 372.734L429.408 397.418",
    stroke: "#1B171C",
    strokeWidth: 3.42006,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.042 387.061L445.056 411.745",
    stroke: "#1B171C",
    strokeWidth: 3.75748,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.792 401.826L461.585 425.849",
    stroke: "#1B171C",
    strokeWidth: 4.12884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.423 416.371L478.775 440.174",
    stroke: "#1B171C",
    strokeWidth: 4.52268,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.937 430.92L497.068 454.061",
    stroke: "#1B171C",
    strokeWidth: 4.95002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.33 445.244L516.021 467.724",
    stroke: "#1B171C",
    strokeWidth: 5.42255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.387 459.35L535.637 480.728",
    stroke: "#1B171C",
    strokeWidth: 5.96251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.104 472.793L556.354 493.29",
    stroke: "#1B171C",
    strokeWidth: 6.60385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.702 486.24L577.512 505.414",
    stroke: "#1B171C",
    strokeWidth: 7.38007,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0661 207.439L-5.64764 209.864",
    stroke: "#1B171C",
    strokeWidth: 0.0224999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6609 207.883L2.72675 211.189",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4771 208.322L10.8818 212.73",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.072 208.76L19.2563 214.049",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6677 209.424L27.4113 215.595",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2625 210.086L35.5651 217.359",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6376 210.967L43.4995 219.121",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0127 212.068L51.4338 221.325",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1672 213.611L59.1476 224.19",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3218 215.816L66.8613 227.277",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2559 218.02L74.5751 230.802",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1898 220.887L82.0682 234.771",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.903 224.189L89.5613 239.176",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.838 227.938L97.0555 243.806",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.552 232.125L104.549 249.316",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.486 236.531L112.042 254.824",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.42 241.379L119.756 260.773",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.575 246.229L127.69 266.725",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.949 251.076L135.844 272.454",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.545 255.928L144.219 278.408",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14 260.775L152.814 284.137",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.176 265.625L161.851 289.868",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.433 270.031L170.887 295.156",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.91 274.441L180.364 300.227",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.827 278.186L190.281 304.853",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.745 281.715L200.199 308.823",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.104 285.02L210.558 312.569",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.682 287.664L221.136 315.434",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.261 289.867L231.935 317.857",
    stroke: "#1B171C",
    strokeWidth: 0.416322,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.281 291.854L242.955 320.064",
    stroke: "#1B171C",
    strokeWidth: 0.472522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.3 293.615L254.195 321.605",
    stroke: "#1B171C",
    strokeWidth: 0.551202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.54 295.156L265.435 323.146",
    stroke: "#1B171C",
    strokeWidth: 0.641343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.78 297.141L276.895 324.69",
    stroke: "#1B171C",
    strokeWidth: 0.742503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.241 299.346L288.356 326.895",
    stroke: "#1B171C",
    strokeWidth: 0.877604,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.701 303.09L300.036 330.198",
    stroke: "#1B171C",
    strokeWidth: 1.02372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.162 309.043L311.497 335.931",
    stroke: "#1B171C",
    strokeWidth: 1.18131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.843 316.312L322.958 342.98",
    stroke: "#1B171C",
    strokeWidth: 1.36137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.744 324.689L334.859 351.137",
    stroke: "#1B171C",
    strokeWidth: 1.55245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.086 334.168L346.981 360.615",
    stroke: "#1B171C",
    strokeWidth: 1.75499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.649 344.967L359.323 370.973",
    stroke: "#1B171C",
    strokeWidth: 1.96877,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.651 356.867L372.326 382.653",
    stroke: "#1B171C",
    strokeWidth: 2.19379,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.096 369.871L385.55 395.216",
    stroke: "#1B171C",
    strokeWidth: 2.41881,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.421 383.314L399.655 408.439",
    stroke: "#1B171C",
    strokeWidth: 2.64383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.408 397.42L414.421 421.883",
    stroke: "#1B171C",
    strokeWidth: 2.86885,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.056 411.744L429.849 435.547",
    stroke: "#1B171C",
    strokeWidth: 3.09387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.585 425.85L445.937 449.211",
    stroke: "#1B171C",
    strokeWidth: 3.3189,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.775 440.176L463.127 462.656",
    stroke: "#1B171C",
    strokeWidth: 3.5437,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.068 454.059L480.979 475.877",
    stroke: "#1B171C",
    strokeWidth: 3.79142,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.021 467.725L499.492 488.442",
    stroke: "#1B171C",
    strokeWidth: 4.0614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.637 480.729L519.108 500.564",
    stroke: "#1B171C",
    strokeWidth: 4.3651,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.353 493.291L539.163 512.024",
    stroke: "#1B171C",
    strokeWidth: 4.71376,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.511 505.412L560.1 522.823",
    stroke: "#1B171C",
    strokeWidth: 5.14132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72661 211.189L-6.30951 214.716",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8812 212.73L1.40424 216.918",
    stroke: "#1B171C",
    strokeWidth: 0.033751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2563 214.051L9.33862 219.34",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4108 215.596L17.0523 221.767",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5653 217.355L24.7661 224.628",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4992 219.121L32.2592 227.496",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4341 221.326L39.7534 230.803",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1476 224.189L47.026 234.548",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8609 227.275L54.2985 238.956",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5752 230.803L61.5721 243.585",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0682 234.768L68.8447 248.432",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5619 239.176L75.8976 253.942",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.055 243.807L83.1702 259.895",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.549 249.316L90.2231 266.287",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.042 254.824L97.4956 272.896",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.755 260.775L104.989 279.729",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.69 266.729L112.923 286.564",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.844 272.457L120.858 293.394",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.22 278.408L129.012 300.007",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.815 284.139L137.608 306.619",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.851 289.867L146.423 313.008",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.886 295.156L155.679 319.179",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.364 300.227L165.157 324.69",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.281 304.854L174.854 329.978",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.199 308.818L184.992 334.604",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.557 312.566L195.35 338.573",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.137 315.434L205.929 341.881",
    stroke: "#1B171C",
    strokeWidth: 0.359901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.936 317.857L216.729 344.745",
    stroke: "#1B171C",
    strokeWidth: 0.405082,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.955 320.061L227.969 346.728",
    stroke: "#1B171C",
    strokeWidth: 0.461282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.196 321.602L239.209 348.489",
    stroke: "#1B171C",
    strokeWidth: 0.528722,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.435 323.146L250.669 349.814",
    stroke: "#1B171C",
    strokeWidth: 0.607403,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.896 324.689L262.35 351.137",
    stroke: "#1B171C",
    strokeWidth: 0.708783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.356 326.893L274.031 352.899",
    stroke: "#1B171C",
    strokeWidth: 0.821184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.037 330.197L285.491 355.983",
    stroke: "#1B171C",
    strokeWidth: 0.956284,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.497 335.928L296.951 361.493",
    stroke: "#1B171C",
    strokeWidth: 1.09116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.958 342.98L308.633 368.326",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.859 351.137L320.313 376.262",
    stroke: "#1B171C",
    strokeWidth: 1.40633,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.981 360.613L332.435 385.297",
    stroke: "#1B171C",
    strokeWidth: 1.57493,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.323 370.975L344.777 395.659",
    stroke: "#1B171C",
    strokeWidth: 1.75499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.325 382.65L357.339 406.673",
    stroke: "#1B171C",
    strokeWidth: 1.92381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.549 395.215L370.562 418.797",
    stroke: "#1B171C",
    strokeWidth: 2.09263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.655 408.439L384.448 431.581",
    stroke: "#1B171C",
    strokeWidth: 2.24999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.421 421.885L398.773 444.585",
    stroke: "#1B171C",
    strokeWidth: 2.39633,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.848 435.547L413.98 457.586",
    stroke: "#1B171C",
    strokeWidth: 2.53121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.937 449.213L430.068 470.591",
    stroke: "#1B171C",
    strokeWidth: 2.66631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.127 462.656L446.598 483.153",
    stroke: "#1B171C",
    strokeWidth: 2.78995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.979 475.881L464.229 495.275",
    stroke: "#1B171C",
    strokeWidth: 2.91381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.493 488.441L482.522 506.954",
    stroke: "#1B171C",
    strokeWidth: 3.04891,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.107 500.562L501.696 517.974",
    stroke: "#1B171C",
    strokeWidth: 3.20627,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.163 512.023L521.531 528.332",
    stroke: "#1B171C",
    strokeWidth: 3.38634,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.101 522.82L542.028 538.027",
    stroke: "#1B171C",
    strokeWidth: 3.61136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.40507 216.92L-7.63098 219.565",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33869 219.342L-0.358582 223.089",
    stroke: "#1B171C",
    strokeWidth: 0.0449998,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0529 221.766L6.69446 226.614",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7662 224.631L13.967 230.361",
    stroke: "#1B171C",
    strokeWidth: 0.0562509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2601 227.496L21.0201 234.328",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7528 230.803L28.072 238.737",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0259 234.549L34.9043 243.585",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2991 238.957L41.7368 248.875",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5723 243.582L48.5691 254.381",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8444 248.436L55.4005 260.337",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8972 253.943L62.2328 266.726",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1704 259.893L69.0652 273.557",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2234 266.285L76.1183 280.831",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4955 272.895L82.9496 288.542",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.989 279.729L90.2231 296.258",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.924 286.562L97.937 303.974",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.858 293.393L105.651 311.465",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.012 300.004L113.805 318.737",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.608 306.615L122.401 325.789",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.423 313.008L130.996 332.843",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68 319.18L140.032 339.456",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.156 324.689L149.509 345.627",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.854 329.98L159.206 351.138",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.992 334.607L169.344 356.206",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.351 338.574L179.703 360.834",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 341.879L190.502 364.359",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.728 344.748L201.301 367.449",
    stroke: "#1B171C",
    strokeWidth: 0.393842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.969 346.729L212.541 369.649",
    stroke: "#1B171C",
    strokeWidth: 0.438802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.208 348.492L224.001 371.413",
    stroke: "#1B171C",
    strokeWidth: 0.495002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.669 349.814L235.682 372.735",
    stroke: "#1B171C",
    strokeWidth: 0.573683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.35 351.137L247.363 373.837",
    stroke: "#1B171C",
    strokeWidth: 0.663823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.031 352.9L259.044 375.38",
    stroke: "#1B171C",
    strokeWidth: 0.776224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.491 355.986L270.725 378.466",
    stroke: "#1B171C",
    strokeWidth: 0.900084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.952 361.496L282.186 383.756",
    stroke: "#1B171C",
    strokeWidth: 1.02372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.632 368.326L293.645 390.365",
    stroke: "#1B171C",
    strokeWidth: 1.15883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.313 376.262L305.546 398.081",
    stroke: "#1B171C",
    strokeWidth: 1.29371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.435 385.297L317.448 407.116",
    stroke: "#1B171C",
    strokeWidth: 1.42881,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.777 395.656L329.57 417.034",
    stroke: "#1B171C",
    strokeWidth: 1.57493,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.339 406.678L342.132 427.835",
    stroke: "#1B171C",
    strokeWidth: 1.71003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.562 418.799L355.135 439.516",
    stroke: "#1B171C",
    strokeWidth: 1.82243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.447 431.578L368.579 451.634",
    stroke: "#1B171C",
    strokeWidth: 1.93505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.772 444.582L382.684 464.197",
    stroke: "#1B171C",
    strokeWidth: 2.02497,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.98 457.584L397.671 476.538",
    stroke: "#1B171C",
    strokeWidth: 2.10387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.069 470.59L413.099 488.882",
    stroke: "#1B171C",
    strokeWidth: 2.18255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.598 483.152L429.628 500.784",
    stroke: "#1B171C",
    strokeWidth: 2.23875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.229 495.273L446.598 512.244",
    stroke: "#1B171C",
    strokeWidth: 2.29495,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.522 506.955L464.45 523.044",
    stroke: "#1B171C",
    strokeWidth: 2.35137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.696 517.973L483.183 533.18",
    stroke: "#1B171C",
    strokeWidth: 2.41881,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.532 528.332L502.358 542.658",
    stroke: "#1B171C",
    strokeWidth: 2.49749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.029 538.029L522.414 551.253",
    stroke: "#1B171C",
    strokeWidth: 2.61011,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69456 226.617L-2.12115 228.16",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9673 230.361L4.27002 233.006",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0199 234.328L10.8818 237.854",
    stroke: "#1B171C",
    strokeWidth: 0.0675019,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0722 238.736L17.2729 243.365",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9042 243.582L23.6641 249.092",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7361 248.873L30.0552 255.264",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5692 254.385L36.4476 261.878",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4011 260.334L42.8387 268.709",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.2333 266.729L49.4505 275.985",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0652 273.557L55.8416 283.695",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1179 280.832L62.4535 291.852",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9503 288.545L69.2859 300.226",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2234 296.26L76.1183 308.602",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9367 303.973L83.3907 316.976",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.65 311.465L91.1045 324.909",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.805 318.74L99.0388 332.845",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4 325.791L107.413 340.557",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.995 332.844L116.009 347.83",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.032 339.457L125.045 354.885",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.509 345.625L134.302 361.493",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.206 351.137L143.999 367.446",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.344 356.205L154.137 372.955",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.702 360.834L164.495 377.804",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.502 364.361L175.074 381.993",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.301 367.443L186.094 385.295",
    stroke: "#1B171C",
    strokeWidth: 0.382602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.541 369.648L197.334 387.721",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.001 371.412L208.794 389.484",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.683 372.734L220.475 390.807",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.363 373.838L232.376 391.91",
    stroke: "#1B171C",
    strokeWidth: 0.641343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.044 375.381L244.277 393.233",
    stroke: "#1B171C",
    strokeWidth: 0.753744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.724 378.469L255.958 396.321",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.185 383.752L267.419 401.604",
    stroke: "#1B171C",
    strokeWidth: 0.978765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.646 390.369L278.88 408.221",
    stroke: "#1B171C",
    strokeWidth: 1.10263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.546 398.08L290.339 415.932",
    stroke: "#1B171C",
    strokeWidth: 1.22627,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.448 407.117L302.24 424.749",
    stroke: "#1B171C",
    strokeWidth: 1.33867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.57 417.035L314.143 434.446",
    stroke: "#1B171C",
    strokeWidth: 1.46253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.132 427.834L326.484 445.245",
    stroke: "#1B171C",
    strokeWidth: 1.56369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.135 439.516L339.267 456.486",
    stroke: "#1B171C",
    strokeWidth: 1.65383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.579 451.635L352.491 468.385",
    stroke: "#1B171C",
    strokeWidth: 1.73251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.684 464.197L366.154 480.506",
    stroke: "#1B171C",
    strokeWidth: 1.78871,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.671 476.543L380.701 492.632",
    stroke: "#1B171C",
    strokeWidth: 1.83367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.099 488.881L395.688 504.308",
    stroke: "#1B171C",
    strokeWidth: 1.85637,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.628 500.783L411.556 515.77",
    stroke: "#1B171C",
    strokeWidth: 1.87885,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.598 512.246L428.085 526.792",
    stroke: "#1B171C",
    strokeWidth: 1.89009,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.45 523.043L445.496 536.928",
    stroke: "#1B171C",
    strokeWidth: 1.90133,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.183 533.182L463.568 546.405",
    stroke: "#1B171C",
    strokeWidth: 1.92381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.357 542.658L482.302 555",
    stroke: "#1B171C",
    strokeWidth: 1.94629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.413 551.254L501.696 562.935",
    stroke: "#1B171C",
    strokeWidth: 1.99125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2702 233.008L-3.22314 231.686",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8813 237.855L2.72675 237.635",
    stroke: "#1B171C",
    strokeWidth: 0.0787508,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2732 243.363L8.67786 243.804",
    stroke: "#1B171C",
    strokeWidth: 0.0900018,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6647 249.098L14.4082 250.64",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0555 255.264L20.3582 257.688",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4471 261.877L26.0886 264.962",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8389 268.709L32.0397 272.676",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4503 275.982L38.2103 280.831",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8421 283.693L44.1613 289.203",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4535 291.854L50.3318 297.804",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2854 300.227L56.723 306.838",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1177 308.602L63.3349 315.875",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.391 316.977L70.3878 324.911",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1046 324.908L77.881 333.504",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0387 332.844L85.5947 341.88",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.414 340.559L93.5291 350.035",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.009 347.83L102.124 357.748",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.045 354.883L110.94 365.241",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.302 361.496L119.976 372.295",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.999 367.443L129.673 378.683",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.137 372.953L139.37 384.414",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.496 377.803L149.729 389.704",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.074 381.992L160.308 394.114",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.094 385.297L171.327 397.859",
    stroke: "#1B171C",
    strokeWidth: 0.393842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.334 387.723L182.567 400.505",
    stroke: "#1B171C",
    strokeWidth: 0.438802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.795 389.484L194.028 402.488",
    stroke: "#1B171C",
    strokeWidth: 0.495002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.475 390.809L205.929 404.032",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.376 391.91L217.83 405.134",
    stroke: "#1B171C",
    strokeWidth: 0.652583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.277 393.232L229.731 406.456",
    stroke: "#1B171C",
    strokeWidth: 0.753744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.959 396.318L241.413 409.542",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.418 401.607L252.873 415.051",
    stroke: "#1B171C",
    strokeWidth: 0.978765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.879 408.217L264.113 421.661",
    stroke: "#1B171C",
    strokeWidth: 1.09116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.34 415.932L275.574 429.596",
    stroke: "#1B171C",
    strokeWidth: 1.20379,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.241 424.748L287.034 438.412",
    stroke: "#1B171C",
    strokeWidth: 1.31619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.142 434.445L298.935 448.11",
    stroke: "#1B171C",
    strokeWidth: 1.41757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.484 445.244L310.837 458.688",
    stroke: "#1B171C",
    strokeWidth: 1.50749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.266 456.484L323.178 470.149",
    stroke: "#1B171C",
    strokeWidth: 1.57493,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.491 468.385L335.961 481.829",
    stroke: "#1B171C",
    strokeWidth: 1.63135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.155 480.504L349.405 493.727",
    stroke: "#1B171C",
    strokeWidth: 1.66507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.701 492.631L363.29 505.634",
    stroke: "#1B171C",
    strokeWidth: 1.67631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.688 504.309L377.836 517.312",
    stroke: "#1B171C",
    strokeWidth: 1.67631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.556 515.771L393.263 528.334",
    stroke: "#1B171C",
    strokeWidth: 1.66507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.085 526.791L409.131 538.913",
    stroke: "#1B171C",
    strokeWidth: 1.65383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.496 536.928L425.881 548.829",
    stroke: "#1B171C",
    strokeWidth: 1.63135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.569 546.402L443.072 557.863",
    stroke: "#1B171C",
    strokeWidth: 1.62011,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.302 555L461.144 566.02",
    stroke: "#1B171C",
    strokeWidth: 1.60887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.696 562.934L479.877 573.512",
    stroke: "#1B171C",
    strokeWidth: 1.60887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.72656 237.634L-3.00366 233.227",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67812 243.802L2.28674 240.275",
    stroke: "#1B171C",
    strokeWidth: 0.101251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4079 250.637L7.35529 247.771",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3582 257.693L12.6445 255.709",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0883 264.963L17.9337 263.641",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0389 272.679L23.4435 272.018",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2098 280.832H28.9533",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1605 289.207L34.4631 289.868",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3316 297.801L40.1935 299.344",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7234 306.838L46.1446 308.821",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3348 315.873L52.3152 318.518",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3874 324.908L58.9269 327.994",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8812 333.506L65.98 337.253",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5946 341.879L73.473 346.066",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5289 350.031L81.1869 354.66",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.125 357.752L89.3418 362.821",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.94 365.24L97.937 370.53",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.976 372.295L106.973 378.025",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.673 378.686L116.229 384.857",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.37 384.416L125.926 391.028",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.729 389.707L136.064 396.76",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.308 394.113L146.423 401.607",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.328 397.859L157.443 405.794",
    stroke: "#1B171C",
    strokeWidth: 0.416322,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.568 400.506L168.683 408.881",
    stroke: "#1B171C",
    strokeWidth: 0.461282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.028 402.488L180.143 411.084",
    stroke: "#1B171C",
    strokeWidth: 0.517482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.929 404.031L192.044 412.627",
    stroke: "#1B171C",
    strokeWidth: 0.596163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.831 405.131L203.946 413.947",
    stroke: "#1B171C",
    strokeWidth: 0.686303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.732 406.455L215.847 415.491",
    stroke: "#1B171C",
    strokeWidth: 0.798704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.412 409.541L227.527 418.797",
    stroke: "#1B171C",
    strokeWidth: 0.911324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.873 415.051L238.768 424.528",
    stroke: "#1B171C",
    strokeWidth: 1.02372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.113 421.66L250.008 431.578",
    stroke: "#1B171C",
    strokeWidth: 1.13635,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.574 429.598L261.248 439.515",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.033 438.414L272.488 448.552",
    stroke: "#1B171C",
    strokeWidth: 1.35013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.935 448.111L283.948 458.47",
    stroke: "#1B171C",
    strokeWidth: 1.45129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.836 458.686L295.629 469.264",
    stroke: "#1B171C",
    strokeWidth: 1.52997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.178 470.148L307.531 480.727",
    stroke: "#1B171C",
    strokeWidth: 1.58617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.961 481.83L319.872 492.629",
    stroke: "#1B171C",
    strokeWidth: 1.62011,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.405 493.732L332.655 504.532",
    stroke: "#1B171C",
    strokeWidth: 1.63135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.29 505.633L346.099 516.432",
    stroke: "#1B171C",
    strokeWidth: 1.63135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.836 517.311L359.984 528.11",
    stroke: "#1B171C",
    strokeWidth: 1.60887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.263 528.332L374.75 539.131",
    stroke: "#1B171C",
    strokeWidth: 1.57493,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.132 538.91L389.957 549.489",
    stroke: "#1B171C",
    strokeWidth: 1.52997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.881 548.83L406.046 559.189",
    stroke: "#1B171C",
    strokeWidth: 1.49625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.072 557.867L422.575 568.226",
    stroke: "#1B171C",
    strokeWidth: 1.45129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.144 566.02L439.766 576.158",
    stroke: "#1B171C",
    strokeWidth: 1.41757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.877 573.512L457.838 583.209",
    stroke: "#1B171C",
    strokeWidth: 1.39509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.28608 240.279L-1.68103 233.227",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35501 247.77L2.72675 241.379",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6447 255.703L7.35529 249.973",
    stroke: "#1B171C",
    strokeWidth: 0.135002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9343 263.64L11.9837 258.791",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4435 272.018L16.8317 267.83",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9538 280.829L21.6808 277.082",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4631 289.865L26.7494 286.779",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1942 299.344L32.0397 296.699",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1446 308.821L37.3289 306.838",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3158 318.519L43.0593 316.977",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9272 327.995L49.2299 327.113",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9797 337.251L55.8416 336.811",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4735 346.068H62.8947",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1871 354.664L70.3878 355.105",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3418 362.816L78.3221 363.698",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9366 370.531L86.4761 372.074",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.972 378.023L95.0712 379.787",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.229 384.857L104.107 387.061",
    stroke: "#1B171C",
    strokeWidth: 0.337421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.927 391.027L113.585 393.672",
    stroke: "#1B171C",
    strokeWidth: 0.359901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.065 396.758L123.503 399.843",
    stroke: "#1B171C",
    strokeWidth: 0.382602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.423 401.607L133.861 405.134",
    stroke: "#1B171C",
    strokeWidth: 0.416322,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.443 405.795L144.44 409.762",
    stroke: "#1B171C",
    strokeWidth: 0.450042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.682 408.879L155.679 413.287",
    stroke: "#1B171C",
    strokeWidth: 0.506242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.143 411.084L167.14 415.933",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.044 412.625L179.041 417.914",
    stroke: "#1B171C",
    strokeWidth: 0.652583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.945 413.947L190.942 419.457",
    stroke: "#1B171C",
    strokeWidth: 0.742503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.847 415.492L202.844 421.443",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.528 418.799L214.524 424.97",
    stroke: "#1B171C",
    strokeWidth: 1.00124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.768 424.527L225.544 431.139",
    stroke: "#1B171C",
    strokeWidth: 1.11387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.008 431.578L236.564 438.631",
    stroke: "#1B171C",
    strokeWidth: 1.23751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.248 439.516L247.583 447.009",
    stroke: "#1B171C",
    strokeWidth: 1.35013,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.488 448.551L258.383 456.485",
    stroke: "#1B171C",
    strokeWidth: 1.45129,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.948 458.469L269.623 466.623",
    stroke: "#1B171C",
    strokeWidth: 1.54121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.629 469.268L280.863 477.863",
    stroke: "#1B171C",
    strokeWidth: 1.62011,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.53 480.729L292.323 489.544",
    stroke: "#1B171C",
    strokeWidth: 1.66507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.873 492.631L304.225 501.447",
    stroke: "#1B171C",
    strokeWidth: 1.68755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.655 504.531L316.566 513.788",
    stroke: "#1B171C",
    strokeWidth: 1.68755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.099 516.432L329.349 525.909",
    stroke: "#1B171C",
    strokeWidth: 1.65383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.984 528.111L342.573 537.588",
    stroke: "#1B171C",
    strokeWidth: 1.60887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.75 539.133L356.678 548.61",
    stroke: "#1B171C",
    strokeWidth: 1.56369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.957 549.488L371.224 559.186",
    stroke: "#1B171C",
    strokeWidth: 1.49625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.046 559.186L386.431 568.883",
    stroke: "#1B171C",
    strokeWidth: 1.42881,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.576 568.223L402.3 577.7",
    stroke: "#1B171C",
    strokeWidth: 1.37261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.766 576.156L418.829 585.633",
    stroke: "#1B171C",
    strokeWidth: 1.31619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.838 583.209L435.799 592.906",
    stroke: "#1B171C",
    strokeWidth: 1.27123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.7269 241.383L-0.358582 233.008",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35565 249.977L3.38861 242.043",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9837 258.792L7.57581 251.299",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8321 267.828L11.7631 260.996",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6807 277.087L15.9504 270.916",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7498 286.781L20.5789 281.051",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0395 296.7L25.2073 291.631",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3282 306.837L30.0552 302.209",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0594 316.975L35.3456 313.008",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2295 327.116L41.075 323.369",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8419 336.812L47.2466 333.506",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8945 346.067L53.8583 343.422",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3872 355.104L60.9103 352.9",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.322 363.699L68.1839 361.936",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4767 372.072L76.1183 370.75",
    stroke: "#1B171C",
    strokeWidth: 0.337421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0716 379.786L84.4927 379.125",
    stroke: "#1B171C",
    strokeWidth: 0.359901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.108 387.058L93.3083 386.838",
    stroke: "#1B171C",
    strokeWidth: 0.382602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.585 393.674L102.345 393.894",
    stroke: "#1B171C",
    strokeWidth: 0.405082,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.502 399.842L112.042 400.503",
    stroke: "#1B171C",
    strokeWidth: 0.438802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.861 405.131L122.18 406.453",
    stroke: "#1B171C",
    strokeWidth: 0.472522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.439 409.76L132.759 411.303",
    stroke: "#1B171C",
    strokeWidth: 0.517482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.679 413.291L143.558 415.495",
    stroke: "#1B171C",
    strokeWidth: 0.573683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.14 415.932L155.019 418.576",
    stroke: "#1B171C",
    strokeWidth: 0.641343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.041 417.914L166.699 421",
    stroke: "#1B171C",
    strokeWidth: 0.731263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.942 419.457L178.821 423.204",
    stroke: "#1B171C",
    strokeWidth: 0.843664,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.844 421.441L190.722 425.629",
    stroke: "#1B171C",
    strokeWidth: 0.978765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.524 424.965L202.182 429.813",
    stroke: "#1B171C",
    strokeWidth: 1.12511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.544 431.139L212.981 436.428",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.564 438.633L223.781 444.363",
    stroke: "#1B171C",
    strokeWidth: 1.37261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.583 447.008L234.36 453.399",
    stroke: "#1B171C",
    strokeWidth: 1.49625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.382 456.484L244.938 463.317",
    stroke: "#1B171C",
    strokeWidth: 1.60887,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.623 466.623L255.738 474.116",
    stroke: "#1B171C",
    strokeWidth: 1.69879,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.863 477.861L266.537 485.575",
    stroke: "#1B171C",
    strokeWidth: 1.75499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.324 489.543L277.778 497.477",
    stroke: "#1B171C",
    strokeWidth: 1.79995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.224 501.445L289.017 510.041",
    stroke: "#1B171C",
    strokeWidth: 1.79995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.567 513.785L300.919 522.38",
    stroke: "#1B171C",
    strokeWidth: 1.77747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.35 525.908L313.041 534.724",
    stroke: "#1B171C",
    strokeWidth: 1.73251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.573 537.59L325.823 546.626",
    stroke: "#1B171C",
    strokeWidth: 1.66507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.678 548.609L339.046 557.866",
    stroke: "#1B171C",
    strokeWidth: 1.58617,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.223 559.186L353.151 568.442",
    stroke: "#1B171C",
    strokeWidth: 1.50749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.431 568.883L367.477 578.36",
    stroke: "#1B171C",
    strokeWidth: 1.42881,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.299 577.701L382.684 587.178",
    stroke: "#1B171C",
    strokeWidth: 1.33867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.828 585.633L398.332 595.11",
    stroke: "#1B171C",
    strokeWidth: 1.27123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.799 592.906L414.641 602.163",
    stroke: "#1B171C",
    strokeWidth: 1.20379,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38859 242.041L0.0827026 233.666",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57533 251.296L3.60822 243.582",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.763 260.996L7.1347 253.723",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9508 270.915L10.8818 264.303",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5786 281.052L14.8483 274.881",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2067 291.631L19.0357 285.9",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0553 302.211L23.4435 296.922",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.345 313.009L28.072 308.16",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.075 323.367L33.3612 319.18",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2459 333.504L38.871 329.758",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8584 343.423L45.0427 340.117",
    stroke: "#1B171C",
    strokeWidth: 0.337421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9111 352.896L51.875 350.031",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1835 361.936L58.9269 359.512",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1174 370.751L66.4201 368.768",
    stroke: "#1B171C",
    strokeWidth: 0.393842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4926 379.129L74.3545 377.586",
    stroke: "#1B171C",
    strokeWidth: 0.416322,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3089 386.841L82.7301 385.959",
    stroke: "#1B171C",
    strokeWidth: 0.438802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.344 393.894L91.7651 393.674",
    stroke: "#1B171C",
    strokeWidth: 0.461282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.042 400.506L101.022 400.726",
    stroke: "#1B171C",
    strokeWidth: 0.495002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.18 406.455L110.94 407.116",
    stroke: "#1B171C",
    strokeWidth: 0.539962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.759 411.305L121.299 412.627",
    stroke: "#1B171C",
    strokeWidth: 0.584923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.558 415.492L132.098 417.035",
    stroke: "#1B171C",
    strokeWidth: 0.652583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.019 418.576L143.338 420.78",
    stroke: "#1B171C",
    strokeWidth: 0.731263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.699 421.002L155.019 423.867",
    stroke: "#1B171C",
    strokeWidth: 0.832424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.821 423.205L166.919 426.731",
    stroke: "#1B171C",
    strokeWidth: 0.956284,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.722 425.629L178.821 429.816",
    stroke: "#1B171C",
    strokeWidth: 1.11387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.182 429.818L190.061 434.667",
    stroke: "#1B171C",
    strokeWidth: 1.27123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.982 436.43L200.64 442.16",
    stroke: "#1B171C",
    strokeWidth: 1.40633,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.781 444.361L211.219 450.753",
    stroke: "#1B171C",
    strokeWidth: 1.54121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.36 453.4L221.578 460.233",
    stroke: "#1B171C",
    strokeWidth: 1.66507,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.938 463.318L231.935 470.591",
    stroke: "#1B171C",
    strokeWidth: 1.77747,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.738 474.115L242.294 481.829",
    stroke: "#1B171C",
    strokeWidth: 1.86761,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.537 485.578L252.652 493.953",
    stroke: "#1B171C",
    strokeWidth: 1.92381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.778 497.477L263.452 506.292",
    stroke: "#1B171C",
    strokeWidth: 1.94629,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.018 510.041L274.472 518.857",
    stroke: "#1B171C",
    strokeWidth: 1.93505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.918 522.383L285.711 531.639",
    stroke: "#1B171C",
    strokeWidth: 1.89009,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.04 534.723L297.392 543.979",
    stroke: "#1B171C",
    strokeWidth: 1.82243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.823 546.625L309.514 556.102",
    stroke: "#1B171C",
    strokeWidth: 1.73251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.046 557.867L322.296 567.564",
    stroke: "#1B171C",
    strokeWidth: 1.63135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.151 568.443L335.52 578.141",
    stroke: "#1B171C",
    strokeWidth: 1.52997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.478 578.361L349.405 587.838",
    stroke: "#1B171C",
    strokeWidth: 1.41757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.684 587.18L363.95 596.877",
    stroke: "#1B171C",
    strokeWidth: 1.32743,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.332 595.111L378.938 604.809",
    stroke: "#1B171C",
    strokeWidth: 1.23751,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.642 602.164L394.586 611.861",
    stroke: "#1B171C",
    strokeWidth: 1.15883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0826616 233.67L-4.3252 226.617",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.60856 243.585L-1.46045 237.193",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.13446 253.726L1.40424 247.996",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8819 264.301L4.49054 259.012",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8482 274.88L8.01599 270.252",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0361 285.902L11.7631 281.715",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4435 296.921L15.7298 293.174",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0726 308.159L19.9181 304.854",
    stroke: "#1B171C",
    strokeWidth: 0.337421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3614 319.179L24.7661 316.094",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.871 329.76L30.0552 327.336",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0423 340.116L35.7858 337.912",
    stroke: "#1B171C",
    strokeWidth: 0.382602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8743 350.035L42.1769 348.492",
    stroke: "#1B171C",
    strokeWidth: 0.405082,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.927 359.512L49.0093 358.41",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4207 368.767L56.0623 368.105",
    stroke: "#1B171C",
    strokeWidth: 0.450042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.3548 377.586H63.776",
    stroke: "#1B171C",
    strokeWidth: 0.472522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7292 385.959L71.9299 386.179",
    stroke: "#1B171C",
    strokeWidth: 0.506242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7653 393.674L80.7457 394.335",
    stroke: "#1B171C",
    strokeWidth: 0.528722,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.022 400.725L89.782 402.047",
    stroke: "#1B171C",
    strokeWidth: 0.573683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.939 407.117L99.479 408.88",
    stroke: "#1B171C",
    strokeWidth: 0.618863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.298 412.625L109.617 414.829",
    stroke: "#1B171C",
    strokeWidth: 0.675063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.097 417.035L120.416 419.9",
    stroke: "#1B171C",
    strokeWidth: 0.742503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.337 420.781L131.656 424.308",
    stroke: "#1B171C",
    strokeWidth: 0.832424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.019 423.865L143.117 428.053",
    stroke: "#1B171C",
    strokeWidth: 0.945044,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.919 426.732L154.798 431.801",
    stroke: "#1B171C",
    strokeWidth: 1.07992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.82 429.818L166.699 435.769",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.061 434.664L177.719 441.496",
    stroke: "#1B171C",
    strokeWidth: 1.41757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.64 442.16L188.077 449.433",
    stroke: "#1B171C",
    strokeWidth: 1.56369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.219 450.754L198.436 458.688",
    stroke: "#1B171C",
    strokeWidth: 1.71003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.577 460.23L208.573 468.826",
    stroke: "#1B171C",
    strokeWidth: 1.83367,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.935 470.59L218.491 479.846",
    stroke: "#1B171C",
    strokeWidth: 1.93505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.294 481.83L228.63 491.527",
    stroke: "#1B171C",
    strokeWidth: 2.01373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.653 493.949L238.768 503.867",
    stroke: "#1B171C",
    strokeWidth: 2.05869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.452 506.291L249.127 516.429",
    stroke: "#1B171C",
    strokeWidth: 2.05869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.471 518.857L259.705 529.216",
    stroke: "#1B171C",
    strokeWidth: 2.02497,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.712 531.637L270.725 541.995",
    stroke: "#1B171C",
    strokeWidth: 1.95753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.392 543.98L281.965 554.559",
    stroke: "#1B171C",
    strokeWidth: 1.86761,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.514 556.102L293.645 566.68",
    stroke: "#1B171C",
    strokeWidth: 1.75499,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.296 567.564L305.767 577.923",
    stroke: "#1B171C",
    strokeWidth: 1.63135,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.521 578.141L318.55 588.499",
    stroke: "#1B171C",
    strokeWidth: 1.50749,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.405 587.838L331.994 598.196",
    stroke: "#1B171C",
    strokeWidth: 1.38385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.951 596.877L345.658 607.015",
    stroke: "#1B171C",
    strokeWidth: 1.27123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.938 604.811L360.204 614.728",
    stroke: "#1B171C",
    strokeWidth: 1.17007,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.585 611.861L374.97 621.559",
    stroke: "#1B171C",
    strokeWidth: 1.07992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4048 247.994L-6.74969 245.35",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.48984 259.015L-4.10553 257.031",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.01659 270.252L-1.23987 268.709",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7633 281.715L2.06598 280.613",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7298 293.173L5.81207 292.512",
    stroke: "#1B171C",
    strokeWidth: 0.359901,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9179 304.857L9.77985 304.637",
    stroke: "#1B171C",
    strokeWidth: 0.382602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7666 316.094L14.1877 316.314",
    stroke: "#1B171C",
    strokeWidth: 0.405082,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0555 327.336L19.2563 327.777",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7857 337.912L24.7661 339.014",
    stroke: "#1B171C",
    strokeWidth: 0.438802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1777 348.492L30.9377 349.815",
    stroke: "#1B171C",
    strokeWidth: 0.461282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0097 358.41L37.3289 360.394",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0616 368.105L44.3807 370.53",
    stroke: "#1B171C",
    strokeWidth: 0.506242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.776 377.586L51.6544 380.231",
    stroke: "#1B171C",
    strokeWidth: 0.539962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9298 386.182L59.8082 389.488",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7462 394.334L68.1839 398.081",
    stroke: "#1B171C",
    strokeWidth: 0.596163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7825 402.047L77.2202 406.014",
    stroke: "#1B171C",
    strokeWidth: 0.641343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4795 408.879L86.6967 413.507",
    stroke: "#1B171C",
    strokeWidth: 0.686303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.618 414.83L96.835 419.899",
    stroke: "#1B171C",
    strokeWidth: 0.742503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.417 419.9L107.634 425.631",
    stroke: "#1B171C",
    strokeWidth: 0.821184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.657 424.307L118.654 430.698",
    stroke: "#1B171C",
    strokeWidth: 0.922564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.118 428.053L130.115 435.105",
    stroke: "#1B171C",
    strokeWidth: 1.03496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.798 431.801L141.795 439.515",
    stroke: "#1B171C",
    strokeWidth: 1.19255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.699 435.768L153.475 444.363",
    stroke: "#1B171C",
    strokeWidth: 1.36137,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.718 441.498L164.495 450.975",
    stroke: "#1B171C",
    strokeWidth: 1.52997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.077 449.434L174.633 459.792",
    stroke: "#1B171C",
    strokeWidth: 1.67631,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.436 458.686L184.771 469.705",
    stroke: "#1B171C",
    strokeWidth: 1.81119,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.574 468.826L194.689 480.287",
    stroke: "#1B171C",
    strokeWidth: 1.93505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.491 479.846L204.386 491.526",
    stroke: "#1B171C",
    strokeWidth: 2.02497,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.629 491.527L214.304 503.649",
    stroke: "#1B171C",
    strokeWidth: 2.08139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.767 503.869L224.222 515.991",
    stroke: "#1B171C",
    strokeWidth: 2.10387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.126 516.432L234.36 528.774",
    stroke: "#1B171C",
    strokeWidth: 2.08139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.705 529.213L244.719 541.775",
    stroke: "#1B171C",
    strokeWidth: 2.02497,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.725 541.996L255.297 554.338",
    stroke: "#1B171C",
    strokeWidth: 1.93505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.965 554.562L266.096 566.684",
    stroke: "#1B171C",
    strokeWidth: 1.82243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.646 566.682L277.557 578.583",
    stroke: "#1B171C",
    strokeWidth: 1.68755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.767 577.92L289.458 589.601",
    stroke: "#1B171C",
    strokeWidth: 1.55245,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.55 588.5L301.58 599.96",
    stroke: "#1B171C",
    strokeWidth: 1.41757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.993 598.197L314.362 609.217",
    stroke: "#1B171C",
    strokeWidth: 1.29371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.658 607.014L327.806 617.593",
    stroke: "#1B171C",
    strokeWidth: 1.17007,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.204 614.725L341.471 625.083",
    stroke: "#1B171C",
    strokeWidth: 1.06868,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.971 621.559L355.797 631.697",
    stroke: "#1B171C",
    strokeWidth: 0.978765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06542 280.613L-10.7174 283.478",
    stroke: "#1B171C",
    strokeWidth: 0.393842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81207 292.512L-7.4115 296.038",
    stroke: "#1B171C",
    strokeWidth: 0.416322,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77961 304.637L-3.66437 308.383",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1874 316.312L0.743469 320.5",
    stroke: "#1B171C",
    strokeWidth: 0.450042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2568 327.775L5.59247 332.404",
    stroke: "#1B171C",
    strokeWidth: 0.472522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7665 339.016L10.8818 343.864",
    stroke: "#1B171C",
    strokeWidth: 0.495002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9369 349.814L16.8317 355.104",
    stroke: "#1B171C",
    strokeWidth: 0.517482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3292 360.393L23.2241 365.902",
    stroke: "#1B171C",
    strokeWidth: 0.539962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3808 370.531L30.0552 376.482",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6544 380.229L37.3289 386.62",
    stroke: "#1B171C",
    strokeWidth: 0.584923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8092 389.484L45.2633 396.317",
    stroke: "#1B171C",
    strokeWidth: 0.618863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1837 398.08L53.6378 405.353",
    stroke: "#1B171C",
    strokeWidth: 0.652583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.22 406.016L62.6741 413.729",
    stroke: "#1B171C",
    strokeWidth: 0.686303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6965 413.508L72.1505 421.442",
    stroke: "#1B171C",
    strokeWidth: 0.742503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8347 419.9L82.2888 428.275",
    stroke: "#1B171C",
    strokeWidth: 0.798704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.634 425.629L93.0879 434.445",
    stroke: "#1B171C",
    strokeWidth: 0.877604,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.653 430.701L104.107 440.178",
    stroke: "#1B171C",
    strokeWidth: 0.978765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.114 435.107L115.568 445.246",
    stroke: "#1B171C",
    strokeWidth: 1.10263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.795 439.516L127.249 450.535",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.476 444.361L138.71 456.483",
    stroke: "#1B171C",
    strokeWidth: 1.41757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.495 450.973L149.509 463.976",
    stroke: "#1B171C",
    strokeWidth: 1.57493,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.634 459.789L159.647 473.233",
    stroke: "#1B171C",
    strokeWidth: 1.71003,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.772 469.709L169.565 483.594",
    stroke: "#1B171C",
    strokeWidth: 1.82243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.689 480.287L179.262 494.613",
    stroke: "#1B171C",
    strokeWidth: 1.92381,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.386 491.527L189.179 506.294",
    stroke: "#1B171C",
    strokeWidth: 1.98001,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.304 503.648L198.876 518.415",
    stroke: "#1B171C",
    strokeWidth: 2.01373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.221 515.99L208.573 530.757",
    stroke: "#1B171C",
    strokeWidth: 2.01373,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.359 528.773L218.491 543.54",
    stroke: "#1B171C",
    strokeWidth: 1.96877,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.718 541.777L228.63 556.103",
    stroke: "#1B171C",
    strokeWidth: 1.89009,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.297 554.338L238.988 568.443",
    stroke: "#1B171C",
    strokeWidth: 1.78871,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.096 566.682L249.787 580.566",
    stroke: "#1B171C",
    strokeWidth: 1.65383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.557 578.582L260.807 591.806",
    stroke: "#1B171C",
    strokeWidth: 1.51873,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.458 589.602L272.268 602.384",
    stroke: "#1B171C",
    strokeWidth: 1.38385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.58 599.959L284.169 612.081",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.363 609.217L296.511 620.898",
    stroke: "#1B171C",
    strokeWidth: 1.12511,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.806 617.592L309.293 628.832",
    stroke: "#1B171C",
    strokeWidth: 1.01248,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.471 625.082L322.738 635.661",
    stroke: "#1B171C",
    strokeWidth: 0.911324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.796 631.697L336.401 641.835",
    stroke: "#1B171C",
    strokeWidth: 0.821184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.743659 320.5L-16.6674 328.875",
    stroke: "#1B171C",
    strokeWidth: 0.495002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59163 332.402L-11.8195 340.998",
    stroke: "#1B171C",
    strokeWidth: 0.517482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.882 343.865L-6.52905 352.681",
    stroke: "#1B171C",
    strokeWidth: 0.528722,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8319 355.104L-0.579102 364.36",
    stroke: "#1B171C",
    strokeWidth: 0.551202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2232 365.902L5.81207 375.6",
    stroke: "#1B171C",
    strokeWidth: 0.573683,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0555 376.484L12.6445 386.402",
    stroke: "#1B171C",
    strokeWidth: 0.596163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3291 386.621L19.9181 396.759",
    stroke: "#1B171C",
    strokeWidth: 0.618863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2625 396.318L27.8514 406.677",
    stroke: "#1B171C",
    strokeWidth: 0.652583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6382 405.354L36.4476 416.153",
    stroke: "#1B171C",
    strokeWidth: 0.686303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6735 413.729L45.4828 424.969",
    stroke: "#1B171C",
    strokeWidth: 0.720023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1512 421.441L55.181 432.902",
    stroke: "#1B171C",
    strokeWidth: 0.764983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2885 428.273L65.3182 440.175",
    stroke: "#1B171C",
    strokeWidth: 0.832424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0885 434.445L76.1183 446.787",
    stroke: "#1B171C",
    strokeWidth: 0.900084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.107 440.176L87.3575 452.959",
    stroke: "#1B171C",
    strokeWidth: 1.00124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.568 445.244L99.0388 458.909",
    stroke: "#1B171C",
    strokeWidth: 1.11387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.249 450.533L110.499 464.859",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.709 456.484L121.96 471.691",
    stroke: "#1B171C",
    strokeWidth: 1.39509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.508 463.977L132.538 479.845",
    stroke: "#1B171C",
    strokeWidth: 1.52997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.647 473.236L142.677 489.545",
    stroke: "#1B171C",
    strokeWidth: 1.64259,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.564 483.592L152.594 500.342",
    stroke: "#1B171C",
    strokeWidth: 1.72127,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.261 494.613L162.291 511.584",
    stroke: "#1B171C",
    strokeWidth: 1.78871,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.18 506.291L171.989 523.261",
    stroke: "#1B171C",
    strokeWidth: 1.82243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.877 518.414L181.686 535.384",
    stroke: "#1B171C",
    strokeWidth: 1.82243,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.574 530.758L191.383 547.508",
    stroke: "#1B171C",
    strokeWidth: 1.78871,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.491 543.539L201.301 559.848",
    stroke: "#1B171C",
    strokeWidth: 1.73251,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.63 556.102L211.219 571.97",
    stroke: "#1B171C",
    strokeWidth: 1.64259,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.988 568.443L221.357 583.871",
    stroke: "#1B171C",
    strokeWidth: 1.52997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.787 580.566L231.935 595.112",
    stroke: "#1B171C",
    strokeWidth: 1.39509,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.806 591.805L242.734 605.91",
    stroke: "#1B171C",
    strokeWidth: 1.27123,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.267 602.387L253.975 615.61",
    stroke: "#1B171C",
    strokeWidth: 1.14759,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.169 612.084L265.435 624.646",
    stroke: "#1B171C",
    strokeWidth: 1.02372,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.511 620.9L277.557 632.802",
    stroke: "#1B171C",
    strokeWidth: 0.911324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.294 628.832L289.899 640.072",
    stroke: "#1B171C",
    strokeWidth: 0.809944,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.737 635.662L302.902 646.241",
    stroke: "#1B171C",
    strokeWidth: 0.720023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.402 641.834L316.126 651.752",
    stroke: "#1B171C",
    strokeWidth: 0.652583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.81225 375.6L-14.9047 388.162",
    stroke: "#1B171C",
    strokeWidth: 0.596163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6448 386.398L-7.85168 399.402",
    stroke: "#1B171C",
    strokeWidth: 0.618863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9176 396.758L-0.358582 409.981",
    stroke: "#1B171C",
    strokeWidth: 0.641343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8519 406.678L7.57581 420.122",
    stroke: "#1B171C",
    strokeWidth: 0.663823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4473 416.152L16.3915 429.817",
    stroke: "#1B171C",
    strokeWidth: 0.686303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4828 424.965L25.6475 438.629",
    stroke: "#1B171C",
    strokeWidth: 0.731263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1801 432.902L35.5651 447.008",
    stroke: "#1B171C",
    strokeWidth: 0.764983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3185 440.176L45.924 454.501",
    stroke: "#1B171C",
    strokeWidth: 0.821184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1179 446.787L56.9437 461.553",
    stroke: "#1B171C",
    strokeWidth: 0.888844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3583 452.959L68.4045 468.166",
    stroke: "#1B171C",
    strokeWidth: 0.978765,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0388 458.91L80.085 474.778",
    stroke: "#1B171C",
    strokeWidth: 1.07992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 464.859L91.5458 481.609",
    stroke: "#1B171C",
    strokeWidth: 1.19255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.959 471.691L103.006 489.102",
    stroke: "#1B171C",
    strokeWidth: 1.30495,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.539 479.846L113.585 497.918",
    stroke: "#1B171C",
    strokeWidth: 1.40633,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.676 489.543L123.722 508.056",
    stroke: "#1B171C",
    strokeWidth: 1.48501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.594 500.344L133.64 518.857",
    stroke: "#1B171C",
    strokeWidth: 1.52997,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.292 511.582L143.338 530.095",
    stroke: "#1B171C",
    strokeWidth: 1.56369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.989 523.264L153.035 541.556",
    stroke: "#1B171C",
    strokeWidth: 1.56369,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.686 535.385L162.732 553.457",
    stroke: "#1B171C",
    strokeWidth: 1.54121,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.383 547.506L172.429 565.358",
    stroke: "#1B171C",
    strokeWidth: 1.49625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.3 559.848L182.126 577.259",
    stroke: "#1B171C",
    strokeWidth: 1.41757,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.218 571.973L192.044 588.723",
    stroke: "#1B171C",
    strokeWidth: 1.32743,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.357 583.871L202.182 599.739",
    stroke: "#1B171C",
    strokeWidth: 1.22627,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.936 595.111L212.321 610.318",
    stroke: "#1B171C",
    strokeWidth: 1.11387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.734 605.912L222.899 620.238",
    stroke: "#1B171C",
    strokeWidth: 1.00124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.974 615.609L233.919 629.274",
    stroke: "#1B171C",
    strokeWidth: 0.888844,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.435 624.645L245.159 637.427",
    stroke: "#1B171C",
    strokeWidth: 0.787464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.557 632.799L256.84 644.7",
    stroke: "#1B171C",
    strokeWidth: 0.697543,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.899 640.07L268.962 651.31",
    stroke: "#1B171C",
    strokeWidth: 0.618863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.902 646.244L281.524 656.823",
    stroke: "#1B171C",
    strokeWidth: 0.551202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.126 651.752L294.307 661.67",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.358274 409.982L-23.2791 424.528",
    stroke: "#1B171C",
    strokeWidth: 0.641343,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.57532 420.119L-15.1252 434.885",
    stroke: "#1B171C",
    strokeWidth: 0.663823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3912 429.818L-6.08893 444.585",
    stroke: "#1B171C",
    strokeWidth: 0.686303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6482 438.633L3.38861 453.84",
    stroke: "#1B171C",
    strokeWidth: 0.720023,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5653 447.008L13.7465 462.435",
    stroke: "#1B171C",
    strokeWidth: 0.753744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9244 454.504L24.3259 470.152",
    stroke: "#1B171C",
    strokeWidth: 0.798704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9435 461.555L35.7858 477.643",
    stroke: "#1B171C",
    strokeWidth: 0.854904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4043 468.164L47.2466 484.694",
    stroke: "#1B171C",
    strokeWidth: 0.922564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0847 474.777L58.9269 491.968",
    stroke: "#1B171C",
    strokeWidth: 1.00124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5458 481.607L70.6085 499.459",
    stroke: "#1B171C",
    strokeWidth: 1.09116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.005 489.102L81.8476 507.615",
    stroke: "#1B171C",
    strokeWidth: 1.18131,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.585 497.916L92.6477 516.87",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.722 508.059L102.785 527.233",
    stroke: "#1B171C",
    strokeWidth: 1.28247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.64 518.857L112.703 538.032",
    stroke: "#1B171C",
    strokeWidth: 1.30495,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.338 530.096L122.401 549.049",
    stroke: "#1B171C",
    strokeWidth: 1.31619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.035 541.557L132.098 560.51",
    stroke: "#1B171C",
    strokeWidth: 1.29371,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.732 553.459L141.795 571.972",
    stroke: "#1B171C",
    strokeWidth: 1.24875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.429 565.357L151.492 583.209",
    stroke: "#1B171C",
    strokeWidth: 1.19255,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.126 577.258L161.189 594.448",
    stroke: "#1B171C",
    strokeWidth: 1.11387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.045 588.719L170.887 605.248",
    stroke: "#1B171C",
    strokeWidth: 1.03496,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.183 599.74L180.805 615.609",
    stroke: "#1B171C",
    strokeWidth: 0.933804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.32 610.318L190.942 625.305",
    stroke: "#1B171C",
    strokeWidth: 0.843664,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.899 620.236L201.301 634.342",
    stroke: "#1B171C",
    strokeWidth: 0.753744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.919 629.271L212.1 642.495",
    stroke: "#1B171C",
    strokeWidth: 0.663823,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.159 637.428L222.899 649.99",
    stroke: "#1B171C",
    strokeWidth: 0.584923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.84 644.701L234.36 656.602",
    stroke: "#1B171C",
    strokeWidth: 0.517482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.961 651.312L246.04 662.332",
    stroke: "#1B171C",
    strokeWidth: 0.450042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.524 656.822L257.942 667.401",
    stroke: "#1B171C",
    strokeWidth: 0.393842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.306 661.67L270.504 671.588",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38804 453.84L-20.4144 468.606",
    stroke: "#1B171C",
    strokeWidth: 0.708783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.747 462.434L-9.83496 477.42",
    stroke: "#1B171C",
    strokeWidth: 0.731263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3259 470.148L1.18469 485.796",
    stroke: "#1B171C",
    strokeWidth: 0.776224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7859 477.643L12.8651 493.511",
    stroke: "#1B171C",
    strokeWidth: 0.821184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.246 484.693L24.5455 501.223",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9276 491.969L36.4476 508.939",
    stroke: "#1B171C",
    strokeWidth: 0.933804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6078 499.463L47.9073 517.094",
    stroke: "#1B171C",
    strokeWidth: 0.990005,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8483 507.613L59.3682 525.906",
    stroke: "#1B171C",
    strokeWidth: 1.0462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6473 516.871L70.1672 535.384",
    stroke: "#1B171C",
    strokeWidth: 1.07992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.786 527.23L80.3055 545.743",
    stroke: "#1B171C",
    strokeWidth: 1.10263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.703 538.029L90.2231 556.542",
    stroke: "#1B171C",
    strokeWidth: 1.10263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.4 549.051L99.9202 567.564",
    stroke: "#1B171C",
    strokeWidth: 1.07992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.097 560.51L109.617 578.582",
    stroke: "#1B171C",
    strokeWidth: 1.0462,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.795 571.973L119.095 589.604",
    stroke: "#1B171C",
    strokeWidth: 1.00124,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.492 583.209L128.571 600.62",
    stroke: "#1B171C",
    strokeWidth: 0.933804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.189 594.449L138.268 610.979",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.886 605.248L147.965 621.116",
    stroke: "#1B171C",
    strokeWidth: 0.787464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.805 615.609L157.664 630.816",
    stroke: "#1B171C",
    strokeWidth: 0.708783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.943 625.307L167.581 639.853",
    stroke: "#1B171C",
    strokeWidth: 0.630103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.301 634.342L177.719 648.006",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1 642.494L188.077 655.497",
    stroke: "#1B171C",
    strokeWidth: 0.495002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.899 649.988L198.656 662.33",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.36 656.598L209.676 668.279",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.04 662.332L220.916 673.572",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.942 667.4L232.376 677.979",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.504 671.586L244.498 681.504",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.18406 485.795L-22.6184 499.68",
    stroke: "#1B171C",
    strokeWidth: 0.753744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8655 493.51L-10.9369 508.056",
    stroke: "#1B171C",
    strokeWidth: 0.787464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5461 501.223L0.964111 516.43",
    stroke: "#1B171C",
    strokeWidth: 0.832424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4471 508.938L12.8651 524.806",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9071 517.094L24.5455 533.403",
    stroke: "#1B171C",
    strokeWidth: 0.911324,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3678 525.908L35.7858 542.658",
    stroke: "#1B171C",
    strokeWidth: 0.933804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1676 535.385L46.3652 552.575",
    stroke: "#1B171C",
    strokeWidth: 0.956284,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3048 545.742L56.5024 563.153",
    stroke: "#1B171C",
    strokeWidth: 0.956284,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2226 556.539L66.4201 573.95",
    stroke: "#1B171C",
    strokeWidth: 0.933804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9207 567.564L76.1183 584.755",
    stroke: "#1B171C",
    strokeWidth: 0.900084,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.618 578.582L85.5947 595.552",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.094 589.602L95.0712 606.131",
    stroke: "#1B171C",
    strokeWidth: 0.809944,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.571 600.621L104.328 616.489",
    stroke: "#1B171C",
    strokeWidth: 0.742503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.268 610.98L113.805 626.628",
    stroke: "#1B171C",
    strokeWidth: 0.686303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.966 621.119L123.282 636.106",
    stroke: "#1B171C",
    strokeWidth: 0.618863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.663 630.816L132.759 645.142",
    stroke: "#1B171C",
    strokeWidth: 0.551202,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.581 639.852L142.236 653.516",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.719 648.006L152.154 661.229",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.078 655.496L162.072 668.279",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.656 662.332L172.429 674.454",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.676 668.279L182.788 679.96",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.916 673.57L193.808 684.59",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.377 677.977L204.828 688.776",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.498 681.504L216.508 692.083",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.963887 516.432L-22.3978 528.994",
    stroke: "#1B171C",
    strokeWidth: 0.809944,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8647 524.807L-10.7174 538.251",
    stroke: "#1B171C",
    strokeWidth: 0.832424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5459 533.4L0.743469 547.506",
    stroke: "#1B171C",
    strokeWidth: 0.854904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7861 542.658L11.9837 557.204",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3644 552.576L22.3415 567.563",
    stroke: "#1B171C",
    strokeWidth: 0.866364,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5024 563.152L32.2592 578.359",
    stroke: "#1B171C",
    strokeWidth: 0.854904,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4209 573.953L41.9573 589.16",
    stroke: "#1B171C",
    strokeWidth: 0.821184,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1179 584.752L51.4338 599.959",
    stroke: "#1B171C",
    strokeWidth: 0.776224,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5943 595.551L60.9103 610.537",
    stroke: "#1B171C",
    strokeWidth: 0.731263,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0715 606.131L70.1672 621.118",
    stroke: "#1B171C",
    strokeWidth: 0.675063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.328 616.49L79.2036 631.257",
    stroke: "#1B171C",
    strokeWidth: 0.618863,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.805 626.627L88.2399 640.732",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.282 636.105L97.4956 649.99",
    stroke: "#1B171C",
    strokeWidth: 0.495002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.759 645.141L106.532 658.585",
    stroke: "#1B171C",
    strokeWidth: 0.438802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.236 653.518L115.789 666.521",
    stroke: "#1B171C",
    strokeWidth: 0.382602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.153 661.229L125.265 673.791",
    stroke: "#1B171C",
    strokeWidth: 0.337421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.071 668.279L134.962 680.401",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.429 674.453L144.66 686.354",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.788 679.963L154.798 691.423",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.808 684.59L165.377 696.05",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.827 688.779L176.176 699.799",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.508 692.086L187.196 702.885",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.743891 547.506L-21.9565 558.966",
    stroke: "#1B171C",
    strokeWidth: 0.843664,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9837 557.205L-11.1575 569.327",
    stroke: "#1B171C",
    strokeWidth: 0.843664,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3424 567.564L-1.01923 580.347",
    stroke: "#1B171C",
    strokeWidth: 0.832424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2599 578.361L8.67786 591.365",
    stroke: "#1B171C",
    strokeWidth: 0.798704,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9566 589.158L17.9337 602.382",
    stroke: "#1B171C",
    strokeWidth: 0.753744,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4338 599.959L27.1906 613.183",
    stroke: "#1B171C",
    strokeWidth: 0.708783,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9108 610.539L36.2269 623.763",
    stroke: "#1B171C",
    strokeWidth: 0.652583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1674 621.119L45.0427 634.122",
    stroke: "#1B171C",
    strokeWidth: 0.596163,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2035 631.256L53.8583 644.039",
    stroke: "#1B171C",
    strokeWidth: 0.539962,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2397 640.734L62.6741 653.517",
    stroke: "#1B171C",
    strokeWidth: 0.483762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.496 649.988L71.2692 662.551",
    stroke: "#1B171C",
    strokeWidth: 0.427562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.532 658.582L80.085 670.704",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.789 666.52L88.9007 678.421",
    stroke: "#1B171C",
    strokeWidth: 0.326181,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.266 673.793L97.937 685.474",
    stroke: "#1B171C",
    strokeWidth: 0.281221,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.962 680.404L107.193 691.865",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.66 686.354L116.67 697.594",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.798 691.422L126.367 702.662",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.377 696.051L136.506 707.07",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.176 699.799L146.864 710.818",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.196 702.885L157.664 713.904",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67725 591.363L-14.0233 601.942",
    stroke: "#1B171C",
    strokeWidth: 0.787464,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9339 602.387L-4.98694 613.186",
    stroke: "#1B171C",
    strokeWidth: 0.742503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1904 613.186L3.8288 624.205",
    stroke: "#1B171C",
    strokeWidth: 0.686303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2262 623.762L12.4238 635.002",
    stroke: "#1B171C",
    strokeWidth: 0.630103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0426 634.121L20.7994 645.361",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.858 644.039L29.174 655.279",
    stroke: "#1B171C",
    strokeWidth: 0.506242,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6742 653.518L37.5494 664.758",
    stroke: "#1B171C",
    strokeWidth: 0.450042,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.269 662.551L45.7034 673.57",
    stroke: "#1B171C",
    strokeWidth: 0.393842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0852 670.707L54.0789 681.727",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9008 678.422L62.6741 689.442",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9368 685.473L71.2692 696.272",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.193 691.863L80.085 702.663",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67 697.594L89.1212 708.393",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.367 702.662L98.3772 713.241",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.506 707.07L108.075 717.649",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.863 710.818L118.212 721.397",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.663 713.902L128.571 724.481",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82877 624.205L-18.2105 633.682",
    stroke: "#1B171C",
    strokeWidth: 0.697543,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4245 635.004L-10.0555 644.481",
    stroke: "#1B171C",
    strokeWidth: 0.630103,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7997 645.359L-2.12115 655.057",
    stroke: "#1B171C",
    strokeWidth: 0.562442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1745 655.279L5.59247 664.977",
    stroke: "#1B171C",
    strokeWidth: 0.495002,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5487 664.756L13.5258 674.453",
    stroke: "#1B171C",
    strokeWidth: 0.438802,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7034 673.57L21.4602 683.268",
    stroke: "#1B171C",
    strokeWidth: 0.382602,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0786 681.727L29.3946 691.424",
    stroke: "#1B171C",
    strokeWidth: 0.337421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.674 689.441L37.3289 699.139",
    stroke: "#1B171C",
    strokeWidth: 0.292461,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.269 696.271L45.7034 706.189",
    stroke: "#1B171C",
    strokeWidth: 0.247501,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0852 702.662L54.0789 712.359",
    stroke: "#1B171C",
    strokeWidth: 0.213752,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1212 708.393L62.6741 718.09",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3778 713.244L71.7103 723.162",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.075 717.65L80.9662 727.568",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.213 721.395L90.8839 731.533",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.571 724.48L101.022 734.619",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59201 664.977L-16.0065 673.572",
    stroke: "#1B171C",
    strokeWidth: 0.517482,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5267 674.453L-8.73297 683.048",
    stroke: "#1B171C",
    strokeWidth: 0.461282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4604 683.268L-1.46045 691.863",
    stroke: "#1B171C",
    strokeWidth: 0.393842,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3942 691.422L6.03259 700.238",
    stroke: "#1B171C",
    strokeWidth: 0.348661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3285 699.139L13.7465 707.954",
    stroke: "#1B171C",
    strokeWidth: 0.303701,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7037 706.189L21.6808 715.005",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0789 712.361L29.8357 721.397",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6736 718.09L37.9896 727.126",
    stroke: "#1B171C",
    strokeWidth: 0.191252,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7098 723.16L46.8054 732.417",
    stroke: "#1B171C",
    strokeWidth: 0.168753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9664 727.568L55.8416 737.045",
    stroke: "#1B171C",
    strokeWidth: 0.146253,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8838 731.531L65.3182 741.008",
    stroke: "#1B171C",
    strokeWidth: 0.123753,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.022 734.619L75.2359 744.316",
    stroke: "#1B171C",
    strokeWidth: 0.112502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03281 700.24L-15.7861 708.174",
    stroke: "#1B171C",
    strokeWidth: 0.371362,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7462 707.953L-8.51349 716.108",
    stroke: "#1B171C",
    strokeWidth: 0.314941,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6812 715.006L-1.01923 723.16",
    stroke: "#1B171C",
    strokeWidth: 0.269981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.835 721.395L6.91406 729.769",
    stroke: "#1B171C",
    strokeWidth: 0.236261,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9896 727.125L14.8483 735.72",
    stroke: "#1B171C",
    strokeWidth: 0.202504,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8061 732.416L23.2241 741.011",
    stroke: "#1B171C",
    strokeWidth: 0.180004,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8421 737.043L32.0397 745.638",
    stroke: "#1B171C",
    strokeWidth: 0.157502,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91484 729.771L-15.3448 737.706",
    stroke: "#1B171C",
    strokeWidth: 0.258741,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.849 735.721L-7.63098 743.875",
    stroke: "#1B171C",
    strokeWidth: 0.225021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1579_43855"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 708,
    height: 752,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutPattern);
export default __webpack_public_path__ + "static/media/about-pattern.8f5355964259a3f3ee299dc6065afea4.svg";
export { ForwardRef as ReactComponent };